{
  "admin.alertsScreen.waGroup.title": {
    "defaultMessage": "Whatsapp group for alerts"
  },
  "admin.dashboard.alertsBody": {
    "defaultMessage": "Configure monitoring notifications"
  },
  "admin.dashboard.alertsBtnText": {
    "defaultMessage": "Manage alerts"
  },
  "admin.dashboard.alertsTitle": {
    "defaultMessage": "Alerts"
  },
  "admin.dashboard.btnLink": {
    "defaultMessage": "Obtain group invite link"
  },
  "admin.dashboard.contentAiBody": {
    "defaultMessage": "Manage Content AI configuration"
  },
  "admin.dashboard.contentAiBtnText": {
    "defaultMessage": "Configure"
  },
  "admin.dashboard.copyLink": {
    "defaultMessage": "Copy link URL"
  },
  "admin.dashboard.coreAdministrationTitle": {
    "defaultMessage": "Core administration"
  },
  "admin.dashboard.featureConfigurationTitle": {
    "defaultMessage": "Feature configuration"
  },
  "admin.dashboard.fragments": {
    "defaultMessage": "Fragments"
  },
  "admin.dashboard.fragmentsBody": {
    "defaultMessage": "Manage fragment configuration"
  },
  "admin.dashboard.fragmentsBtnText": {
    "defaultMessage": "Configure"
  },
  "admin.dashboard.groupsBtnText": {
    "defaultMessage": "Manage groups"
  },
  "admin.dashboard.socialIntegrationsTitle": {
    "defaultMessage": "Platform integration"
  },
  "admin.dashboard.stationsBody": {
    "defaultMessage": "There {count, plural, one {is} other {are} } {countBold} registered {count, plural, one {station} other {stations} }"
  },
  "admin.dashboard.stationsBtnText": {
    "defaultMessage": "Manage stations"
  },
  "admin.dashboard.stationsTitle": {
    "defaultMessage": "Stations"
  },
  "admin.dashboard.title": {
    "defaultMessage": "Administration"
  },
  "admin.dashboard.usersBody": {
    "defaultMessage": "There {count, plural, one {is} other {are} } {countBold} registered {count, plural, one {user} other {users} }"
  },
  "admin.dashboard.usersBtnText": {
    "defaultMessage": "Manage users"
  },
  "admin.dashboard.usersTitle": {
    "defaultMessage": "Users and groups"
  },
  "admin.dashboard.videoAnalysisBody": {
    "defaultMessage": "Configure automatic video analysis"
  },
  "admin.dashboard.videoAnalysisBtnText": {
    "defaultMessage": "Configure"
  },
  "admin.dashboard.videoAnalysisTitle": {
    "defaultMessage": "Video Analysis"
  },
  "admin.dashboard.youtubeBtnText": {
    "defaultMessage": "Configure"
  },
  "admin.fragments.addNewFooter": {
    "defaultMessage": "Add new footer"
  },
  "admin.fragments.configUpdated": {
    "defaultMessage": "Fragment configuration for {stationName} updated"
  },
  "admin.fragments.footers": {
    "defaultMessage": "Footers in description"
  },
  "admin.fragments.fragmentsConfigUpdated": {
    "defaultMessage": "Fragment configuration for {stationName} updated"
  },
  "admin.fragments.newFooterName": {
    "defaultMessage": "New footer"
  },
  "admin.fragments.noFooters": {
    "defaultMessage": "No footers registered"
  },
  "admin.fragments.registeredFootersTitle": {
    "defaultMessage": "Registered footers"
  },
  "admin.fragments.tagGroups": {
    "defaultMessage": "Tag groups"
  },
  "admin.fragments.title": {
    "defaultMessage": "Fragments"
  },
  "admin.fragments.twoDefaultsNotAllowed": {
    "defaultMessage": "There cannot be two footers set as default"
  },
  "admin.fragments.useAsDefault": {
    "defaultMessage": "Use as default"
  },
  "admin.fragments.watermark": {
    "defaultMessage": "Media watermark"
  },
  "admin.fragments.watermark.active": {
    "defaultMessage": "Active"
  },
  "admin.fragments.watermark.configTitle": {
    "defaultMessage": "Configuration"
  },
  "admin.fragments.watermark.imageTitle": {
    "defaultMessage": "Image"
  },
  "admin.fragments.watermark.loadLabel": {
    "defaultMessage": "Load watermark"
  },
  "admin.fragments.watermark.opacity": {
    "defaultMessage": "Opacity"
  },
  "admin.fragments.watermark.paddingX": {
    "defaultMessage": "Padding X"
  },
  "admin.fragments.watermark.paddingY": {
    "defaultMessage": "Padding Y"
  },
  "admin.fragments.watermark.positionBottom": {
    "defaultMessage": "Bottom"
  },
  "admin.fragments.watermark.positionCenter": {
    "defaultMessage": "Center"
  },
  "admin.fragments.watermark.positionLeft": {
    "defaultMessage": "Left"
  },
  "admin.fragments.watermark.positionRight": {
    "defaultMessage": "Right"
  },
  "admin.fragments.watermark.positionTitle": {
    "defaultMessage": "Position"
  },
  "admin.fragments.watermark.positionTop": {
    "defaultMessage": "Top"
  },
  "admin.fragments.watermark.positionX": {
    "defaultMessage": "Position X"
  },
  "admin.fragments.watermark.positionY": {
    "defaultMessage": "Position Y"
  },
  "admin.groups.addScreen.helpLinkText": {
    "defaultMessage": "What is a group?"
  },
  "admin.groups.alertsScreen.title": {
    "defaultMessage": "Alerts"
  },
  "admin.groups.deleteScreen.btn": {
    "defaultMessage": "Delete group"
  },
  "admin.groups.deleteScreen.prompt": {
    "defaultMessage": "Do you really want to delete the group <b>{name}</b>? {br} This action cannot be undone."
  },
  "admin.groups.deleteScreen.title": {
    "defaultMessage": "Delete group"
  },
  "admin.groups.editScreen.title": {
    "defaultMessage": "Edit group"
  },
  "admin.groups.filters.namePlaceholder": {
    "defaultMessage": "Search by name"
  },
  "admin.groups.form.name.label": {
    "defaultMessage": "Name"
  },
  "admin.groups.form.name.placeholder": {
    "defaultMessage": "For example \"Top Stations Users\""
  },
  "admin.groups.form.users.help": {
    "defaultMessage": "<b>NOTE:</b> users may belong to only one group. Selected users which are linked to other groups will be overridden."
  },
  "admin.groups.form.users.label": {
    "defaultMessage": "Assigned users"
  },
  "admin.groups.form.users.noMore": {
    "defaultMessage": "No more available users"
  },
  "admin.groups.help.assignGroup": {
    "defaultMessage": "By setting a user's group, they will be given access to all the stations the group has access to. You can manage which groups have access to a station under <strong>Admin {'>'} Station {'>'} Groups Permissions</strong>."
  },
  "admin.groups.help.intro": {
    "defaultMessage": "<strong>Groups</strong> are a useful method to organize users and control access and permissions for stations in a simple way."
  },
  "admin.groups.help.oneGroup": {
    "defaultMessage": "A user can belong only to <strong>one</strong> group. If you need to give specific access to a user beyond their assigned group, you can assign an individual permission under <strong>Admin {'>'} Station {'>'} Users Permissions</strong>."
  },
  "admin.groups.listScreen.links.createGroup": {
    "defaultMessage": "Create group"
  },
  "admin.groups.listScreen.noGroups": {
    "defaultMessage": "No groups found"
  },
  "admin.groups.listScreen.title": {
    "defaultMessage": "Manage groups"
  },
  "admin.groups.listScreen.usersCountHeader": {
    "defaultMessage": "# Users"
  },
  "admin.groups.notifications.created": {
    "defaultMessage": "Group created"
  },
  "admin.groups.notifications.deleted": {
    "defaultMessage": "Group deleted"
  },
  "admin.groups.notifications.updated": {
    "defaultMessage": "Group updated"
  },
  "admin.groups.viewScreen.actionsPermissionsTab": {
    "defaultMessage": "Action permissions"
  },
  "admin.groups.viewScreen.assignedUsers.body": {
    "defaultMessage": "This group <b> {count, plural, =0 {has no} one {has #} other {has #} } </b> {count, plural, one {assigned user} other {assigned users} }"
  },
  "admin.groups.viewScreen.assignedUsers.title": {
    "defaultMessage": "Assigned users"
  },
  "admin.groups.viewScreen.basicInfoTab": {
    "defaultMessage": "Info"
  },
  "admin.groups.viewScreen.notDeletableHelp": {
    "defaultMessage": "This group can't be deleted because it contains assigned users"
  },
  "admin.groups.viewScreen.permissions.filterPlaceholder": {
    "defaultMessage": "Filter stations"
  },
  "admin.groups.viewScreen.permissions.noFilterMatch": {
    "defaultMessage": "No matching stations found"
  },
  "admin.groups.viewScreen.permissions.updateError": {
    "defaultMessage": "Could not update permission"
  },
  "admin.groups.viewScreen.stationsPermissionsTab": {
    "defaultMessage": "Station permissions"
  },
  "admin.integrations.accept": {
    "defaultMessage": "Accept"
  },
  "admin.integrations.cancel": {
    "defaultMessage": "Cancel"
  },
  "admin.integrations.warningTitle": {
    "defaultMessage": "Attention"
  },
  "admin.permissions.reset": {
    "defaultMessage": "Reset"
  },
  "admin.permissions.resetPermissions": {
    "defaultMessage": "Reset permissions"
  },
  "admin.permissions.resetPermissionsPrompt": {
    "defaultMessage": "Are you sure you want to reset all permissions? This action cannot be undone."
  },
  "admin.permissionsLabel": {
    "defaultMessage": "Admin"
  },
  "admin.socialExport.body": {
    "defaultMessage": "Configure upload to {platformName} for fragments"
  },
  "admin.socialExport.title": {
    "defaultMessage": "Integration with {name}"
  },
  "admin.stations.editScreen.title": {
    "defaultMessage": "Edit station"
  },
  "admin.stations.filters.namePlaceholder": {
    "defaultMessage": "Search by name"
  },
  "admin.stations.listScreen.title": {
    "defaultMessage": "Stations"
  },
  "admin.stations.viewScreen.basicInfo": {
    "defaultMessage": "Info"
  },
  "admin.stations.viewScreen.groups": {
    "defaultMessage": "Groups"
  },
  "admin.stations.viewScreen.groupsFilter": {
    "defaultMessage": "Filter groups"
  },
  "admin.stations.viewScreen.groupsPermissions": {
    "defaultMessage": "Group permissions"
  },
  "admin.stations.viewScreen.logo": {
    "defaultMessage": "Logo"
  },
  "admin.stations.viewScreen.noGroups": {
    "defaultMessage": "No groups found"
  },
  "admin.stations.viewScreen.noGroupsFound": {
    "defaultMessage": "No matching groups found"
  },
  "admin.stations.viewScreen.noUsersFound": {
    "defaultMessage": "No users found"
  },
  "admin.stations.viewScreen.permissionInherited": {
    "defaultMessage": "Permission inherited from group {groupName}"
  },
  "admin.stations.viewScreen.permissionUpdateError": {
    "defaultMessage": "Could not update permission"
  },
  "admin.stations.viewScreen.userLinkText": {
    "defaultMessage": "View user info"
  },
  "admin.stations.viewScreen.usersFilter": {
    "defaultMessage": "Filter users"
  },
  "admin.stations.viewScreen.usersPermissions": {
    "defaultMessage": "User permissions"
  },
  "admin.tagGroups.deleteGroupConfirm": {
    "defaultMessage": "Are you sure you want to delete the group?"
  },
  "admin.tagGroups.deleteGroupTitle": {
    "defaultMessage": "Delete group"
  },
  "admin.tagGroups.newGroupName": {
    "defaultMessage": "New group"
  },
  "admin.sidebar.configuration": {
    "defaultMessage": "Features"
  },
  "admin.sidebar.groups": {
    "defaultMessage": "Groups"
  },
  "admin.sidebar.integrations": {
    "defaultMessage": "Platforms"
  },
  "admin.sidebar.organization": {
    "defaultMessage": "Organization"
  },
  "admin.sidebar.stationGroups": {
    "defaultMessage": "Station groups"
  },
  "admin.stationGroups.breadcrumb": {
    "defaultMessage": "Station groups"
  },
  "admin.stationGroups.filters.namePlaceholder": {
    "defaultMessage": "Search by name"
  },
  "admin.stationGroups.listScreen.stationsCountHeader": {
    "defaultMessage": "# Stations"
  },
  "admin.stationGroups.listScreen.title": {
    "defaultMessage": "Station groups"
  },
  "admin.stationGroups.viewScreen.accessType": {
    "defaultMessage": "Access"
  },
  "admin.stationGroups.viewScreen.accessType.owned": {
    "defaultMessage": "Owned"
  },
  "admin.stationGroups.viewScreen.accessType.shared": {
    "defaultMessage": "Shared"
  },
  "admin.stationGroups.viewScreen.noStations": {
    "defaultMessage": "No stations in this group"
  },
  "admin.stationGroups.viewScreen.slug": {
    "defaultMessage": "Slug"
  },
  "admin.stationGroups.viewScreen.stations": {
    "defaultMessage": "Stations"
  },
  "admin.title": {
    "defaultMessage": "Admin"
  },
  "admin.users.addScreen.title": {
    "defaultMessage": "Create user"
  },
  "admin.users.deleteScreen.prompt": {
    "defaultMessage": "Do you want to delete the user <b>{email}</b>? {br} This action can not be undone."
  },
  "admin.users.deleteScreen.title": {
    "defaultMessage": "Delete user"
  },
  "admin.users.editScreen.title": {
    "defaultMessage": "Edit user"
  },
  "admin.users.filters.emailPlaceholder": {
    "defaultMessage": "Search by email"
  },
  "admin.users.filters.namePlaceholder": {
    "defaultMessage": "Search by name"
  },
  "admin.users.form.errors.errorUserExistsNotification": {
    "defaultMessage": "User already exists"
  },
  "admin.users.form.group.label": {
    "defaultMessage": "Group"
  },
  "admin.users.form.group.noGroup": {
    "defaultMessage": "No group"
  },
  "admin.users.form.name.label": {
    "defaultMessage": "Name"
  },
  "admin.users.form.surname.label": {
    "defaultMessage": "Last name"
  },
  "admin.users.lastLogin": {
    "defaultMessage": "Last login"
  },
  "admin.users.listScreen.links.createUser": {
    "defaultMessage": "Create user"
  },
  "admin.users.listScreen.title": {
    "defaultMessage": "Manage users"
  },
  "admin.users.loginMethod.label": {
    "defaultMessage": "Login method"
  },
  "admin.users.loginMethod.SOCIAL_LOGIN.description": {
    "defaultMessage": "User will use their existing Google email account to sign in."
  },
  "admin.users.loginMethod.SOCIAL_LOGIN.label": {
    "defaultMessage": "Login with Google"
  },
  "admin.users.loginMethod.USERNAME_PASSWORD.description": {
    "defaultMessage": "User will receive an email with instructions to set up their account"
  },
  "admin.users.loginMethod.USERNAME_PASSWORD.label": {
    "defaultMessage": "Username and password"
  },
  "admin.users.name": {
    "defaultMessage": "Name"
  },
  "admin.users.notifications.created": {
    "defaultMessage": "User created"
  },
  "admin.users.notifications.deleted": {
    "defaultMessage": "User deleted"
  },
  "admin.users.notifications.updated": {
    "defaultMessage": "User updated"
  },
  "admin.users.role": {
    "defaultMessage": "Role"
  },
  "admin.users.roles.label": {
    "defaultMessage": "User role"
  },
  "admin.users.roles.values.CLIENT_ADMIN.description": {
    "defaultMessage": "Client administrator user"
  },
  "admin.users.roles.values.CLIENT_ADMIN.label": {
    "defaultMessage": "Administrator"
  },
  "admin.users.roles.values.CLIENT_USER.description": {
    "defaultMessage": "Standard client user"
  },
  "admin.users.roles.values.CLIENT_USER.label": {
    "defaultMessage": "Basic"
  },
  "admin.users.roles.values.SUPERADMIN.description": {
    "defaultMessage": "System administrator"
  },
  "admin.users.roles.values.SUPERADMIN.label": {
    "defaultMessage": "Super administrator"
  },
  "admin.users.title": {
    "defaultMessage": "Users"
  },
  "admin.users.viewScreen.actionsPermissionsTab": {
    "defaultMessage": "Action permissions"
  },
  "admin.users.viewScreen.assignedGroup.noGroup": {
    "defaultMessage": "- No group -"
  },
  "admin.users.viewScreen.assignedGroup.title": {
    "defaultMessage": "Assigned group"
  },
  "admin.users.viewScreen.basicInfoTab": {
    "defaultMessage": "Info"
  },
  "admin.users.viewScreen.fullName": {
    "defaultMessage": "Full name"
  },
  "admin.users.viewScreen.permissions.clientAdminAllStationsAccess": {
    "defaultMessage": "Admin users have access to all stations by default."
  },
  "admin.users.viewScreen.permissions.filterPlaceholder": {
    "defaultMessage": "Filter stations"
  },
  "admin.users.viewScreen.permissions.noFilterMatch": {
    "defaultMessage": "No matching stations found"
  },
  "admin.users.viewScreen.permissions.updateError": {
    "defaultMessage": "Could not update permission"
  },
  "admin.users.viewScreen.stationsPermissionsTab": {
    "defaultMessage": "Station permissions"
  },
  "admin.users.viewScreen.userRole": {
    "defaultMessage": "User role"
  },
  "admin.videoAnalysis.adOverlays.ignoredEntities": {
    "defaultMessage": "Ignored entities"
  },
  "admin.videoAnalysis.adOverlays.notEnabledForStation": {
    "defaultMessage": "Ad Overlays not enabled for this station"
  },
  "admin.videoAnalysis.adOverlays.numericAllowlist": {
    "defaultMessage": "Numeric allowlist"
  },
  "admin.videoAnalysis.adOverlays.title": {
    "defaultMessage": "Ad Overlays"
  },
  "admin.videoAnalysis.settingsUpdated": {
    "defaultMessage": "Settings updated"
  },
  "assets.fileUploaded": {
    "defaultMessage": "File uploaded"
  },
  "assets.upload.error": {
    "defaultMessage": "An error occurred while uploading the file, please try again"
  },
  "assets.upload.errorFileSizeExceeded": {
    "defaultMessage": "Files must not exceed {maxSizeMb}MB"
  },
  "assets.upload.label": {
    "defaultMessage": "Upload asset"
  },
  "assets.upload.maxSize": {
    "defaultMessage": "Max. {max}MB."
  },
  "assets.viewFile": {
    "defaultMessage": "View file"
  },
  "audit.adaptiveRun.noActions": {
    "defaultMessage": "No actions"
  },
  "audit.adoverlayScreen.brand": {
    "defaultMessage": "Brand"
  },
  "audit.adoverlayScreen.duration": {
    "defaultMessage": "Duration"
  },
  "audit.adoverlayScreen.image": {
    "defaultMessage": "Image"
  },
  "audit.adoverlayScreen.loading": {
    "defaultMessage": "Loading ad overlays"
  },
  "audit.adoverlayScreen.noResults": {
    "defaultMessage": "No ad overlays found"
  },
  "audit.aod.actions.acceptRun": {
    "defaultMessage": "Accept"
  },
  "audit.aod.actions.acceptRun.description": {
    "defaultMessage": "Accept the report result and run again so it gets exported"
  },
  "audit.aod.actions.acceptRun.reason": {
    "defaultMessage": "Reason (optional)"
  },
  "audit.aod.actions.acceptRun.reason.placeholder": {
    "defaultMessage": "Enter an optional reason to accept this run"
  },
  "audit.aod.actions.downloadExport": {
    "defaultMessage": "Download export"
  },
  "audit.aod.actions.goToReport": {
    "defaultMessage": "Go to report"
  },
  "audit.aod.actions.orderReprocess": {
    "defaultMessage": "Reprocess order {orderId}"
  },
  "audit.aod.actions.orderReprocess.completed": {
    "defaultMessage": "Order {orderId} reprocessed"
  },
  "audit.aod.actions.orderReprocess.completed.multiple": {
    "defaultMessage": "Orders reprocessed: {currentOrders}"
  },
  "audit.aod.actions.orderReprocess.confirm.button": {
    "defaultMessage": "Confirm"
  },
  "audit.aod.actions.orderReprocess.confirm.message": {
    "defaultMessage": "Are you sure you want to start reprocessing order {orderId}?"
  },
  "audit.aod.actions.orderReprocess.confirm.message.withKey": {
    "defaultMessage": "Are you sure you want to start reprocessing order {orderId}? (key: {key})"
  },
  "audit.aod.actions.orderReprocess.confirm.title": {
    "defaultMessage": "Confirm reprocessing"
  },
  "audit.aod.actions.orderReprocess.multiple": {
    "defaultMessage": "Reprocess {count} orders"
  },
  "audit.aod.actions.orderReprocess.processing": {
    "defaultMessage": "Reprocessing order {orderId}"
  },
  "audit.aod.actions.orderReprocess.processing.multiple": {
    "defaultMessage": "Reprocessing orders {currentOrders}"
  },
  "audit.aod.actions.orderReprocess.reprocessedOn": {
    "defaultMessage": "Reprocessed on {date, date, long} {date, time, short}"
  },
  "audit.aod.actions.orderReprocess.reprocessedOn.withKey": {
    "defaultMessage": "Reprocessed on {date, date, long} {date, time, short} (key: {key})"
  },
  "audit.aod.actions.refreshRun": {
    "defaultMessage": "Refresh"
  },
  "audit.aod.actions.refreshRun.description": {
    "defaultMessage": "Re-run the execution with existing results without changing export conditions"
  },
  "audit.aod.actions.refreshRun.description.missingMaterials": {
    "defaultMessage": "After uploading the missing materials, refresh the run to re-evaluate the report."
  },
  "audit.aod.actions.restartRun": {
    "defaultMessage": "Restart run"
  },
  "audit.aod.actions.restartRun.message": {
    "defaultMessage": "Are you sure you want to restart this run? This will remove its report and re-queue processing."
  },
  "audit.aod.actions.restartRun.title": {
    "defaultMessage": "Restart run"
  },
  "audit.aod.actions.triggerReprocess": {
    "defaultMessage": "Reprocess"
  },
  "audit.aod.actions.triggerReprocess.completed": {
    "defaultMessage": "Reprocessing completed"
  },
  "audit.aod.actions.triggerReprocess.description": {
    "defaultMessage": "Start order reprocessing and then re-run the execution"
  },
  "audit.aod.actions.triggerReprocess.error": {
    "defaultMessage": "Could not start reprocessing"
  },
  "audit.aod.actions.triggerReprocess.error.missingMaterials": {
    "defaultMessage": "Cannot reprocess: materials are missing. Upload the audios and refresh the run."
  },
  "audit.aod.actions.triggerReprocess.failed.message": {
    "defaultMessage": "There are issues that need to be resolved with the reprocess:"
  },
  "audit.aod.actions.triggerReprocess.failed.missingSegments": {
    "defaultMessage": "Missing segments:"
  },
  "audit.aod.actions.triggerReprocess.failed.missingSpotMedia": {
    "defaultMessage": "Missing spot media:"
  },
  "audit.aod.actions.triggerReprocess.failed.title": {
    "defaultMessage": "Reprocess error"
  },
  "audit.aod.actions.triggerReprocess.missingMaterials.description": {
    "defaultMessage": "Unmatched schedules have no linked spot media. Upload the materials and refresh the run; OLAF reprocessing cannot help without audio."
  },
  "audit.aod.actions.triggerReprocess.missingMaterials.title": {
    "defaultMessage": "Reprocess unavailable"
  },
  "audit.aod.actions.triggerReprocess.startedAt": {
    "defaultMessage": "Started on"
  },
  "audit.aod.actions.triggerReprocess.waiting": {
    "defaultMessage": "Reprocessing is waiting to start"
  },
  "audit.aod.actions.viewResults": {
    "defaultMessage": "View results"
  },
  "audit.aod.exportConditions.description": {
    "defaultMessage": "Description"
  },
  "audit.aod.exportConditions.description.placeholder": {
    "defaultMessage": "Optional description for this manual execution"
  },
  "audit.aod.exportConditions.enableEfficiency": {
    "defaultMessage": "Check minimum efficiency"
  },
  "audit.aod.exportConditions.minEfficiency": {
    "defaultMessage": "Minimum efficiency"
  },
  "audit.aod.exportConditions.minEfficiency.help": {
    "defaultMessage": "Minimum efficiency (0 to 100%)"
  },
  "audit.aod.exportConditions.minEfficiency.placeholder": {
    "defaultMessage": "0 - 100"
  },
  "audit.aod.gip.atLeastOneAdvertiser": {
    "defaultMessage": "At least one advertiser must be selected"
  },
  "audit.aod.gip.export.packageStorageStrategy.PER_RULE": {
    "defaultMessage": "Per rule"
  },
  "audit.aod.gip.export.packageStorageStrategy.PER_RUN": {
    "defaultMessage": "Per run"
  },
  "audit.aod.gip.export.packageStorageStrategyLabel": {
    "defaultMessage": "Package storage"
  },
  "audit.aod.gip.order": {
    "defaultMessage": "Order"
  },
  "audit.aod.review.evidenceExportTitle": {
    "defaultMessage": "Evidence export"
  },
  "audit.aod.review.exportConditionsTitle": {
    "defaultMessage": "Export conditions"
  },
  "audit.aod.review.reportConfigTitle": {
    "defaultMessage": "Report configuration"
  },
  "audit.aod.rules.active": {
    "defaultMessage": "Active"
  },
  "audit.aod.rules.add": {
    "defaultMessage": "Create rule"
  },
  "audit.aod.rules.add.reportType": {
    "defaultMessage": "Report type"
  },
  "audit.aod.rules.addScreen.title": {
    "defaultMessage": "Create AOD rule"
  },
  "audit.aod.rules.createdAt": {
    "defaultMessage": "Created"
  },
  "audit.aod.rules.createdBy": {
    "defaultMessage": "by"
  },
  "audit.aod.rules.delete.message": {
    "defaultMessage": "Are you sure you want to delete the rule \"{name}\"? This action cannot be undone."
  },
  "audit.aod.rules.delete.title": {
    "defaultMessage": "Delete AOD rule"
  },
  "audit.aod.rules.edit.updateBtn": {
    "defaultMessage": "Update rule"
  },
  "audit.aod.rules.editScreen.title": {
    "defaultMessage": "Edit AOD rule"
  },
  "audit.aod.rules.field.active": {
    "defaultMessage": "Status"
  },
  "audit.aod.rules.field.createdAt": {
    "defaultMessage": "Created"
  },
  "audit.aod.rules.field.name": {
    "defaultMessage": "Name"
  },
  "audit.aod.rules.field.reportType": {
    "defaultMessage": "Report type"
  },
  "audit.aod.rules.field.trigger": {
    "defaultMessage": "Trigger"
  },
  "audit.aod.rules.managers": {
    "defaultMessage": "Managers"
  },
  "audit.aod.rules.managers.help": {
    "defaultMessage": "Select the users who will be responsible for this rule"
  },
  "audit.aod.rules.managers.placeholder": {
    "defaultMessage": "Select users"
  },
  "audit.aod.rules.manualRun.exportConditions": {
    "defaultMessage": "Export conditions"
  },
  "audit.aod.rules.manualRun.exportConditionsDescription": {
    "defaultMessage": "Modify the export conditions for this manual execution. Changes will only apply to this execution."
  },
  "audit.aod.rules.manualRun.notifications.error": {
    "defaultMessage": "Error starting manual execution"
  },
  "audit.aod.rules.manualRun.notifications.triggered": {
    "defaultMessage": "Manual execution started"
  },
  "audit.aod.rules.manualRun.submit": {
    "defaultMessage": "Start manual execution"
  },
  "audit.aod.rules.manualRunScreen.title": {
    "defaultMessage": "Execute AOD rule manually"
  },
  "audit.aod.rules.name": {
    "defaultMessage": "Name"
  },
  "audit.aod.rules.name.placeholder": {
    "defaultMessage": "Enter the rule name"
  },
  "audit.aod.rules.notificationPolicy.ALWAYS": {
    "defaultMessage": "Always (week-end and order-end)"
  },
  "audit.aod.rules.notificationPolicy.label": {
    "defaultMessage": "Notification policy"
  },
  "audit.aod.rules.notificationPolicy.NONE": {
    "defaultMessage": "No notifications"
  },
  "audit.aod.rules.notificationPolicy.ORDER_END_ONLY": {
    "defaultMessage": "Order-end only"
  },
  "audit.aod.rules.notifications.created": {
    "defaultMessage": "AOD rule created"
  },
  "audit.aod.rules.notifications.createError": {
    "defaultMessage": "Error creating AOD rule."
  },
  "audit.aod.rules.notifications.deleted": {
    "defaultMessage": "AOD rule deleted"
  },
  "audit.aod.rules.notifications.deleteError": {
    "defaultMessage": "Error deleting AOD rule"
  },
  "audit.aod.rules.notifications.updated": {
    "defaultMessage": "AOD rule updated"
  },
  "audit.aod.rules.notifications.updateError": {
    "defaultMessage": "Error updating AOD rule"
  },
  "audit.aod.rules.reportType": {
    "defaultMessage": "Report type"
  },
  "audit.aod.rules.review.basicInfo": {
    "defaultMessage": "Basic Information"
  },
  "audit.aod.rules.review.createBtn": {
    "defaultMessage": "Create rule"
  },
  "audit.aod.rules.rule": {
    "defaultMessage": "Rule"
  },
  "audit.aod.rules.title": {
    "defaultMessage": "Rules"
  },
  "audit.aod.rules.trigger": {
    "defaultMessage": "Trigger"
  },
  "audit.aod.rules.trigger.EOW": {
    "defaultMessage": "Weekly close"
  },
  "audit.aod.rules.trigger.EOW_AND_ORDER_END": {
    "defaultMessage": "Weekly close + order end"
  },
  "audit.aod.rules.trigger.EOW_AND_ORDER_END_SHORT": {
    "defaultMessage": "Close + end"
  },
  "audit.aod.rules.trigger.MANUAL": {
    "defaultMessage": "Manual"
  },
  "audit.aod.rules.trigger.ORDER_END": {
    "defaultMessage": "Order end"
  },
  "audit.aod.rules.view.runs.navigation.activeAndPast": {
    "defaultMessage": "Active/past runs"
  },
  "audit.aod.rules.view.runs.navigation.future": {
    "defaultMessage": "Scheduled Executions"
  },
  "audit.aod.rules.view.runs.noFutureRuns": {
    "defaultMessage": "No scheduled executions for this rule."
  },
  "audit.aod.rules.view.runs.triggerManual": {
    "defaultMessage": "Execute manually"
  },
  "audit.aod.rules.view.tabs.exportConditions": {
    "defaultMessage": "Export Conditions"
  },
  "audit.aod.rules.view.tabs.exportOptions": {
    "defaultMessage": "Export Options"
  },
  "audit.aod.rules.view.tabs.info": {
    "defaultMessage": "Information"
  },
  "audit.aod.rules.view.tabs.reportConfig": {
    "defaultMessage": "Report Configuration"
  },
  "audit.aod.rules.view.tabs.runs": {
    "defaultMessage": "Executions"
  },
  "audit.aod.rules.wizard.basicInfo": {
    "defaultMessage": "Basic information"
  },
  "audit.aod.rules.wizard.exportConditions": {
    "defaultMessage": "Export conditions"
  },
  "audit.aod.rules.wizard.exportOptions": {
    "defaultMessage": "Evidence export"
  },
  "audit.aod.rules.wizard.reportConfig": {
    "defaultMessage": "Report configuration"
  },
  "audit.aod.rules.wizard.review": {
    "defaultMessage": "Review"
  },
  "audit.aod.runs.actions.triggerRunCopy": {
    "defaultMessage": "Run copy now"
  },
  "audit.aod.runs.actions.triggerRunCopySuccess": {
    "defaultMessage": "Run started"
  },
  "audit.aod.runs.actions.viewRule": {
    "defaultMessage": "Go to rule"
  },
  "audit.aod.runs.completionReason.LOW_EFFICIENCY": {
    "defaultMessage": "Low efficiency"
  },
  "audit.aod.runs.completionReason.MISSING_MATERIALS": {
    "defaultMessage": "Missing materials"
  },
  "audit.aod.runs.datetime": {
    "defaultMessage": "Executed"
  },
  "audit.aod.runs.field.actions": {
    "defaultMessage": "Actions"
  },
  "audit.aod.runs.field.completionComment": {
    "defaultMessage": "Comment"
  },
  "audit.aod.runs.field.completionReason": {
    "defaultMessage": "Reason"
  },
  "audit.aod.runs.field.deficiencyNotificationsSent": {
    "defaultMessage": "Deficiency notifications sent"
  },
  "audit.aod.runs.field.deficiencyNotificationsUsers": {
    "defaultMessage": "Notified users"
  },
  "audit.aod.runs.field.description": {
    "defaultMessage": "Description"
  },
  "audit.aod.runs.field.efficiency": {
    "defaultMessage": "Efficiency"
  },
  "audit.aod.runs.field.interval": {
    "defaultMessage": "Interval"
  },
  "audit.aod.runs.field.minEfficiency": {
    "defaultMessage": "Minimum efficiency required"
  },
  "audit.aod.runs.field.order": {
    "defaultMessage": "Order"
  },
  "audit.aod.runs.field.ruleName": {
    "defaultMessage": "Rule"
  },
  "audit.aod.runs.field.runAt": {
    "defaultMessage": "Executed at"
  },
  "audit.aod.runs.field.status": {
    "defaultMessage": "Status"
  },
  "audit.aod.runs.field.type": {
    "defaultMessage": "Type"
  },
  "audit.aod.runs.interval": {
    "defaultMessage": "Interval"
  },
  "audit.aod.runs.name": {
    "defaultMessage": "Name"
  },
  "audit.aod.runs.order": {
    "defaultMessage": "Order"
  },
  "audit.aod.runs.reportType": {
    "defaultMessage": "Report type"
  },
  "audit.aod.runs.rule": {
    "defaultMessage": "Rule"
  },
  "audit.aod.runs.ruleName": {
    "defaultMessage": "Rule"
  },
  "audit.aod.runs.scheduledAt": {
    "defaultMessage": "Scheduled"
  },
  "audit.aod.runs.status": {
    "defaultMessage": "Status"
  },
  "audit.aod.runs.status.completed_with_export": {
    "defaultMessage": "Executed with export"
  },
  "audit.aod.runs.status.completed_without_export": {
    "defaultMessage": "Executed without export"
  },
  "audit.aod.runs.status.failed": {
    "defaultMessage": "Failed"
  },
  "audit.aod.runs.status.in_progress": {
    "defaultMessage": "In progress"
  },
  "audit.aod.runs.status.pending": {
    "defaultMessage": "Pending"
  },
  "audit.aod.runs.status.waiting_for_reprocess": {
    "defaultMessage": "Waiting for reprocess"
  },
  "audit.aod.runs.title": {
    "defaultMessage": "Executions"
  },
  "audit.aod.runs.type": {
    "defaultMessage": "Trigger"
  },
  "audit.aod.runs.userAccepted.intro": {
    "defaultMessage": "Run manually accepted by user"
  },
  "audit.aod.runs.userAccepted.reason": {
    "defaultMessage": "Reason:"
  },
  "audit.aod.runs.userReprocess.intro": {
    "defaultMessage": "Manual reprocessing requested by user"
  },
  "audit.aod.runs.userReprocess.onDate": {
    "defaultMessage": "on"
  },
  "audit.aod.runs.userReprocess.unknownUser": {
    "defaultMessage": "unknown user"
  },
  "audit.aod.tabs.rules": {
    "defaultMessage": "AOD Rules"
  },
  "audit.aod.tabs.runsPast": {
    "defaultMessage": "Past Executions"
  },
  "audit.aod.tabs.runsScheduled": {
    "defaultMessage": "Scheduled Executions"
  },
  "audit.aod.titleLong": {
    "defaultMessage": "Automatic Order Delivery"
  },
  "audit.audiosScreen.customData.name": {
    "defaultMessage": "Name"
  },
  "audit.audiosScreen.customData.value": {
    "defaultMessage": "Value"
  },
  "audit.audiosScreen.customDataTitle": {
    "defaultMessage": "Custom data for {customId}"
  },
  "audit.audiosScreen.group": {
    "defaultMessage": "Group"
  },
  "audit.audiosScreen.mediaTitle": {
    "defaultMessage": "Media"
  },
  "audit.audiosScreen.props.audioId": {
    "defaultMessage": "Media ID"
  },
  "audit.audiosScreen.props.date": {
    "defaultMessage": "Uploaded at"
  },
  "audit.audiosScreen.props.duration": {
    "defaultMessage": "Duration"
  },
  "audit.audiosScreen.props.filename": {
    "defaultMessage": "Filename"
  },
  "audit.audiosScreen.showCustomData": {
    "defaultMessage": "Show custom data"
  },
  "audit.audiosScreen.showTranscription": {
    "defaultMessage": "Show transcription"
  },
  "audit.audiosScreen.tabTitle": {
    "defaultMessage": "Media"
  },
  "audit.audiosScreen.title": {
    "defaultMessage": "Uploaded files"
  },
  "audit.audiosScreen.transcriptionTitle": {
    "defaultMessage": "Transcription for {customId}"
  },
  "audit.auditConfig.materials": {
    "defaultMessage": "Materials"
  },
  "audit.bcr.label": {
    "defaultMessage": "BCR"
  },
  "audit.bcr.verifiedWithBcr": {
    "defaultMessage": "Verified with BCR"
  },
  "audit.bcrMatchesReport.emptyState.help": {
    "defaultMessage": "Compares imported BCR logs with system matches for the selected day. Helps verify which external log airings were confirmed and which were not."
  },
  "audit.branding.headerBackgroundColor": {
    "defaultMessage": "Header background color"
  },
  "audit.broadcastEvidence.downloadPackage": {
    "defaultMessage": "Download evidence (ZIP)"
  },
  "audit.broadcastEvidence.downloadPending": {
    "defaultMessage": "Evidence package not available"
  },
  "audit.broadcastEvidence.evidenceTitle": {
    "defaultMessage": "Evidence"
  },
  "audit.broadcastEvidence.jobStatus": {
    "defaultMessage": "Status"
  },
  "audit.broadcastEvidence.localDate": {
    "defaultMessage": "Date"
  },
  "audit.broadcastEvidence.orderId": {
    "defaultMessage": "Order"
  },
  "audit.broadcastEvidence.packageTitle": {
    "defaultMessage": "Evidence export"
  },
  "audit.broadcastEvidence.scheduledMaterial": {
    "defaultMessage": "Scheduled material"
  },
  "audit.broadcastEvidence.station": {
    "defaultMessage": "Station"
  },
  "audit.broadcastEvidence.summary.alternativeConfirmed": {
    "defaultMessage": "Confirmed"
  },
  "audit.broadcastEvidence.summary.olafMatched": {
    "defaultMessage": "OLAF"
  },
  "audit.broadcastEvidence.summary.outsideTolerance": {
    "defaultMessage": "Outside tolerance"
  },
  "audit.broadcastEvidence.summary.scheduled": {
    "defaultMessage": "Scheduled"
  },
  "audit.broadcastEvidence.summary.withinTolerance": {
    "defaultMessage": "Within tolerance"
  },
  "audit.broadcastEvidence.table.broadcastDatetime": {
    "defaultMessage": "Broadcast"
  },
  "audit.broadcastEvidence.table.broadcastMaterialId": {
    "defaultMessage": "Broadcast material"
  },
  "audit.broadcastEvidence.table.methods": {
    "defaultMessage": "Methods"
  },
  "audit.broadcastEvidence.table.observation": {
    "defaultMessage": "Observation"
  },
  "audit.broadcastEvidence.table.scheduledMaterialId": {
    "defaultMessage": "Scheduled material"
  },
  "audit.broadcastEvidence.table.status": {
    "defaultMessage": "Status"
  },
  "audit.broadcastEvidence.table.withinTolerance": {
    "defaultMessage": "Tolerance"
  },
  "audit.broadcastEvidence.withinTolerance.no": {
    "defaultMessage": "No"
  },
  "audit.broadcastEvidence.withinTolerance.yes": {
    "defaultMessage": "Yes"
  },
  "audit.column.moveToEnd": {
    "defaultMessage": "Move to end"
  },
  "audit.column.moveToStart": {
    "defaultMessage": "Move to start"
  },
  "audit.configScreen.excludedCustomIds.hint": {
    "defaultMessage": "List of custom IDs separated by comma that will be excluded from audit reports"
  },
  "audit.configScreen.excludedCustomIds.label": {
    "defaultMessage": "Exclude custom IDs"
  },
  "audit.configScreen.successMessage": {
    "defaultMessage": "Audit config updated"
  },
  "audit.configScreen.title": {
    "defaultMessage": "Audit config"
  },
  "audit.confirmedBySchedule.filterByOrder": {
    "defaultMessage": "View schedules for order {order}"
  },
  "audit.confirmedBySchedule.scheduleDatetime": {
    "defaultMessage": "Schedule"
  },
  "audit.consecutiveSchedules.datetimeNext": {
    "defaultMessage": "Next date and time"
  },
  "audit.consecutiveSchedules.title": {
    "defaultMessage": "Consecutive schedules"
  },
  "audit.controls.markers": {
    "defaultMessage": "Markers"
  },
  "audit.diarization.processing": {
    "defaultMessage": "Processing transcription"
  },
  "audit.equalMd5Report.customIds": {
    "defaultMessage": "Custom IDs"
  },
  "audit.equalMd5Report.emptyState.help": {
    "defaultMessage": "Lists media files that share the same MD5 hash (i.e. identical file content) but are registered under different material IDs. Useful for detecting and cleaning up duplicate media."
  },
  "audit.equalMd5Report.md5": {
    "defaultMessage": "MD5"
  },
  "audit.filesUpload.audioIdLabel": {
    "defaultMessage": "Media ID:"
  },
  "audit.filesUpload.entriesFoundToLoad": {
    "defaultMessage": "Found {n} {type} entries to load. Confirm load or cancel to go back."
  },
  "audit.filesUpload.fileLabel": {
    "defaultMessage": "File:"
  },
  "audit.filesUpload.filesLabel": {
    "defaultMessage": "Files:"
  },
  "audit.filesUpload.links.adAudios": {
    "defaultMessage": "Spot media"
  },
  "audit.filesUpload.links.adSchedulesAsc": {
    "defaultMessage": "Spot schedules (ASC)"
  },
  "audit.filesUpload.links.adSchedulesPlk": {
    "defaultMessage": "Spot schedules (PLK)"
  },
  "audit.filesUpload.links.avgUpload": {
    "defaultMessage": "AVG upload"
  },
  "audit.filesUpload.links.bcrUpload": {
    "defaultMessage": "BCR upload"
  },
  "audit.filesUpload.links.liveMentionSchedulesCsv": {
    "defaultMessage": "Mention schedules (CSV)"
  },
  "audit.filesUpload.links.ltxUpload": {
    "defaultMessage": "LTX upload"
  },
  "audit.filesUpload.materialId": {
    "defaultMessage": "Material ID"
  },
  "audit.filesUpload.selectFileLabel": {
    "defaultMessage": "Select file(s) .{type}"
  },
  "audit.filesUpload.selectFileType": {
    "defaultMessage": "Select a file type from the side menu"
  },
  "audit.filesUpload.uploadError": {
    "defaultMessage": "An error occurred while uploading the file:"
  },
  "audit.filesUpload.uploadFile": {
    "defaultMessage": "Confirm load"
  },
  "audit.filesUpload.uploadFiles": {
    "defaultMessage": "Confirm load"
  },
  "audit.filesUpload.uploading": {
    "defaultMessage": "Uploading..."
  },
  "audit.filesUpload.uploadSuccess": {
    "defaultMessage": "File uploaded successfully"
  },
  "audit.filesUpload.uploadSuccessMultiple": {
    "defaultMessage": "Files uploaded successfully"
  },
  "audit.filesUpload.validateError": {
    "defaultMessage": "An error occurred while validating the file:"
  },
  "audit.gip.exportConditions.enableEfficiency": {
    "defaultMessage": "Check minimum efficiency"
  },
  "audit.gip.exportConditions.minEfficiency": {
    "defaultMessage": "Minimum efficiency"
  },
  "audit.gip.report.efficiency": {
    "defaultMessage": "Efficiency"
  },
  "audit.gip.report.efficiencyHelp": {
    "defaultMessage": "Percentage of processed schedules that have a confirmed match."
  },
  "audit.gip.report.missingMaterials": {
    "defaultMessage": "Missing materials"
  },
  "audit.gip.report.missingMaterialsHelp": {
    "defaultMessage": "Number of materials referenced by schedules that are not uploaded yet."
  },
  "audit.gip.report.results": {
    "defaultMessage": "Results"
  },
  "audit.gip.report.scheduleProgress": {
    "defaultMessage": "Schedule progress"
  },
  "audit.gip.report.scheduleProgressHelp": {
    "defaultMessage": "Percentage of schedules already processed out of the total. Pending and future schedules are not counted as processed yet."
  },
  "audit.gip.report.summary": {
    "defaultMessage": "Summary"
  },
  "audit.gip.report.totalSchedules": {
    "defaultMessage": "Total schedules"
  },
  "audit.gip.report.withMatch": {
    "defaultMessage": "With match"
  },
  "audit.gip.report.withoutMatch": {
    "defaultMessage": "Without match"
  },
  "audit.gipReport.columnMaterial": {
    "defaultMessage": "Material"
  },
  "audit.gipReport.columnStation": {
    "defaultMessage": "Station"
  },
  "audit.gipReport.configTitle": {
    "defaultMessage": "Report configuration"
  },
  "audit.gipReport.createModal.createdNotification": {
    "defaultMessage": "Report created"
  },
  "audit.gipReport.createModal.createdNotificationLink": {
    "defaultMessage": "View report"
  },
  "audit.gipReport.createModal.nameLabel": {
    "defaultMessage": "Name"
  },
  "audit.gipReport.createModal.namePlaceholder": {
    "defaultMessage": "Enter report name"
  },
  "audit.gipReport.createModal.title": {
    "defaultMessage": "Create GIP report"
  },
  "audit.gipReport.error.dateRangeExceeded": {
    "defaultMessage": "The date range cannot exceed {maxDays} days."
  },
  "audit.gipReport.error.fromMustBeBeforeTo": {
    "defaultMessage": "The start date must be before the end date."
  },
  "audit.gipReport.excludedMatchesCount": {
    "defaultMessage": "{count, plural, one {match excluded} other {matches excluded}}"
  },
  "audit.gipReport.excludedMatchesLabel": {
    "defaultMessage": "Matches excluded from export"
  },
  "audit.gipReport.export.advancedLink": {
    "defaultMessage": "Advanced"
  },
  "audit.gipReport.export.audioMatchIncludeAfterLabel": {
    "defaultMessage": "Seconds to include after match"
  },
  "audit.gipReport.export.audioMatchIncludeBeforeLabel": {
    "defaultMessage": "Seconds to include before match"
  },
  "audit.gipReport.export.audioMatchIncludeHelper": {
    "defaultMessage": "Between 0 and 300 seconds"
  },
  "audit.gipReport.export.customTextInPath": {
    "defaultMessage": "Custom text in path"
  },
  "audit.gipReport.export.definition": {
    "defaultMessage": "Template"
  },
  "audit.gipReport.export.excludeVersion": {
    "defaultMessage": "Exclude version"
  },
  "audit.gipReport.export.filesConfig": {
    "defaultMessage": "File configuration"
  },
  "audit.gipReport.export.noTemplatesAvailable": {
    "defaultMessage": "No templates available"
  },
  "audit.gipReport.export.pathFormat": {
    "defaultMessage": "Path format"
  },
  "audit.gipReport.export.publicLink": {
    "defaultMessage": "Public link"
  },
  "audit.gipReport.export.retryBtn": {
    "defaultMessage": "Start again"
  },
  "audit.gipReport.export.startBtn": {
    "defaultMessage": "Start export"
  },
  "audit.gipReport.export.startNotification": {
    "defaultMessage": "Export started"
  },
  "audit.gipReport.export.startNotificationError": {
    "defaultMessage": "Error starting export"
  },
  "audit.gipReport.export.title": {
    "defaultMessage": "Export report"
  },
  "audit.gipReport.export.xlsConfig": {
    "defaultMessage": "XLS configuration"
  },
  "audit.gipReport.exportModal.createdNotificationError": {
    "defaultMessage": "Error creating report"
  },
  "audit.gipReport.form.advertisers": {
    "defaultMessage": "Advertisers"
  },
  "audit.gipReport.form.allAdvertisers": {
    "defaultMessage": "All advertisers"
  },
  "audit.gipReport.form.allCampaigns": {
    "defaultMessage": "All campaigns"
  },
  "audit.gipReport.form.allOrders": {
    "defaultMessage": "All orders"
  },
  "audit.gipReport.form.allStationsDefault": {
    "defaultMessage": "All stations"
  },
  "audit.gipReport.form.allVersions": {
    "defaultMessage": "All versions"
  },
  "audit.gipReport.form.campaigns": {
    "defaultMessage": "Campaigns"
  },
  "audit.gipReport.form.customField": {
    "defaultMessage": "Custom field"
  },
  "audit.gipReport.form.customFieldValue": {
    "defaultMessage": "Custom field"
  },
  "audit.gipReport.form.customIds": {
    "defaultMessage": "Custom ID"
  },
  "audit.gipReport.form.endDate": {
    "defaultMessage": "End date"
  },
  "audit.gipReport.form.endTime": {
    "defaultMessage": "End time"
  },
  "audit.gipReport.form.loadOrderParams": {
    "defaultMessage": "Load order params"
  },
  "audit.gipReport.form.loadOrderParamsMultiple": {
    "defaultMessage": "Load orders params"
  },
  "audit.gipReport.form.orders": {
    "defaultMessage": "Orders"
  },
  "audit.gipReport.form.selectCustom": {
    "defaultMessage": "Select custom"
  },
  "audit.gipReport.form.startDate": {
    "defaultMessage": "Start date"
  },
  "audit.gipReport.form.startTime": {
    "defaultMessage": "Start time"
  },
  "audit.gipReport.form.stations": {
    "defaultMessage": "Stations"
  },
  "audit.gipReport.form.typeToSearch": {
    "defaultMessage": "Enter at least 2 initial characters"
  },
  "audit.gipReport.form.versions": {
    "defaultMessage": "Versions"
  },
  "audit.gipReport.includeAllMatches": {
    "defaultMessage": "Include all matches found in the export"
  },
  "audit.gipReport.info.createBtn": {
    "defaultMessage": "Save report"
  },
  "audit.gipReport.info.end": {
    "defaultMessage": "End date/time"
  },
  "audit.gipReport.info.start": {
    "defaultMessage": "Start date/time"
  },
  "audit.gipReport.noCustomFieldFilter": {
    "defaultMessage": "No custom field filter"
  },
  "audit.gipReport.result.advertiser": {
    "defaultMessage": "Advertiser"
  },
  "audit.gipReport.result.campaign": {
    "defaultMessage": "Campaign"
  },
  "audit.gipReport.result.contract": {
    "defaultMessage": "Contract"
  },
  "audit.gipReport.result.date": {
    "defaultMessage": "Date"
  },
  "audit.gipReport.result.dateTime": {
    "defaultMessage": "Date & time"
  },
  "audit.gipReport.result.duration": {
    "defaultMessage": "Duration"
  },
  "audit.gipReport.result.matchDateTime": {
    "defaultMessage": "Match date & time"
  },
  "audit.gipReport.result.material.missing": {
    "defaultMessage": "Material {customId} missing"
  },
  "audit.gipReport.result.order": {
    "defaultMessage": "Order"
  },
  "audit.gipReport.result.schedule": {
    "defaultMessage": "Schedule"
  },
  "audit.gipReport.result.showOffTolerance": {
    "defaultMessage": "Show off tolerance"
  },
  "audit.gipReport.result.station": {
    "defaultMessage": "Station"
  },
  "audit.gipReport.result.tabs.future": {
    "defaultMessage": "Future"
  },
  "audit.gipReport.result.tabs.long.future": {
    "defaultMessage": "Future schedules"
  },
  "audit.gipReport.result.tabs.long.missingMaterials": {
    "defaultMessage": "Schedules with missing materials"
  },
  "audit.gipReport.result.tabs.long.toBeProcessed": {
    "defaultMessage": "Schedules to be processed"
  },
  "audit.gipReport.result.tabs.long.withMatches": {
    "defaultMessage": "Schedules with matches"
  },
  "audit.gipReport.result.tabs.long.withoutMatches": {
    "defaultMessage": "Schedules without matches"
  },
  "audit.gipReport.result.tabs.missingMaterials": {
    "defaultMessage": "Missing materials"
  },
  "audit.gipReport.result.tabs.toBeProcessed": {
    "defaultMessage": "To be processed"
  },
  "audit.gipReport.result.tabs.withMatches": {
    "defaultMessage": "With matches"
  },
  "audit.gipReport.result.tabs.withoutMatches": {
    "defaultMessage": "Without matches"
  },
  "audit.gipReport.result.type": {
    "defaultMessage": "Type"
  },
  "audit.gipReport.result.version": {
    "defaultMessage": "Version"
  },
  "audit.gipReport.resultOptions": {
    "defaultMessage": "Result options"
  },
  "audit.gipReport.title": {
    "defaultMessage": "GIP report"
  },
  "audit.globalMissingAudios.groupByHelp.groupByCustomId": {
    "defaultMessage": "Group by <b>custom ID</b>: schedules are grouped by custom ID, so that it will only return one schedule for each missing media, for any of the selected radios."
  },
  "audit.globalMissingAudios.groupByHelp.groupByCustomIdAndRadio": {
    "defaultMessage": "Group by <b>custom ID and radio</b>: it returns a single schedule for each station and each custom ID."
  },
  "audit.globalMissingAudios.groupByHelp.intro": {
    "defaultMessage": "This option allows to group schedules with missing media:"
  },
  "audit.globalMissingAudios.groupByHelp.noGroup": {
    "defaultMessage": "<b>Do not group</b>: returns all of the found schedules. It might return multiple schedules with the same custom ID."
  },
  "audit.globalReports.title": {
    "defaultMessage": "Global reports"
  },
  "audit.liveMention.badge": {
    "defaultMessage": "Live Mention"
  },
  "audit.liveMentions.acceptMention": {
    "defaultMessage": "Accept mention"
  },
  "audit.liveMentions.created": {
    "defaultMessage": "Manual mention created"
  },
  "audit.liveMentions.createError": {
    "defaultMessage": "Mention not created, please try again"
  },
  "audit.liveMentions.mentionMatch": {
    "defaultMessage": "Mention Match"
  },
  "audit.liveMentions.processingMessage": {
    "defaultMessage": "Live mentions are being processed. Results will be available shortly."
  },
  "audit.liveMentions.rejectConfirm": {
    "defaultMessage": "Confirm reject"
  },
  "audit.liveMentions.rejected": {
    "defaultMessage": "Mention rejected"
  },
  "audit.liveMentions.rejectMention": {
    "defaultMessage": "Reject mention"
  },
  "audit.liveMentions.selectFromSchedules": {
    "defaultMessage": "Select a mention from schedules"
  },
  "audit.liveMentions.status.ACCEPTED": {
    "defaultMessage": "Accepted"
  },
  "audit.liveMentions.status.AUTO": {
    "defaultMessage": "Auto"
  },
  "audit.liveMentions.status.MANUAL": {
    "defaultMessage": "Manual"
  },
  "audit.liveMentions.status.REJECTED": {
    "defaultMessage": "Rejected"
  },
  "audit.liveMentionsAdd.createCustomMention": {
    "defaultMessage": "Create a custom mention"
  },
  "audit.liveMentionsAdd.mentionFromSchedules": {
    "defaultMessage": "Mention from schedules"
  },
  "audit.liveMentionsAdd.title": {
    "defaultMessage": "Add live mention"
  },
  "audit.liveMentionsScreen.noResults": {
    "defaultMessage": "No results found"
  },
  "audit.lowerthird.duration": {
    "defaultMessage": "Duration"
  },
  "audit.lowerthird.title": {
    "defaultMessage": "Lowerthird"
  },
  "audit.lowerthirdScreen.loading": {
    "defaultMessage": "Loading lower thirds"
  },
  "audit.lowerthirdScreen.noResults": {
    "defaultMessage": "No lower thirds found"
  },
  "audit.ltxMatchesReport.emptyState.help": {
    "defaultMessage": "Compares imported LTX logs with system matches for the selected day. Helps verify which external log airings were confirmed and which were not."
  },
  "audit.matchCategory.adOverlays": {
    "defaultMessage": "AD OVERLAYS"
  },
  "audit.matchCategory.customAds": {
    "defaultMessage": "SPOT"
  },
  "audit.matchCategory.mentions": {
    "defaultMessage": "MENTIONS"
  },
  "audit.matches.spotMatch": {
    "defaultMessage": "Spot Match"
  },
  "audit.matchesAdd.created": {
    "defaultMessage": "Match created"
  },
  "audit.matchesAdd.createError": {
    "defaultMessage": "Error creating match"
  },
  "audit.matchesAdd.playedDuration": {
    "defaultMessage": "Played duration"
  },
  "audit.matchesAdd.title": {
    "defaultMessage": "Add match"
  },
  "audit.matchesAdd.useAudioDuration": {
    "defaultMessage": "Use media duration"
  },
  "audit.matchesScreen.downloadBtn": {
    "defaultMessage": "Download media"
  },
  "audit.matchesScreen.showOnStreamBtn": {
    "defaultMessage": "Show on stream"
  },
  "audit.matchesScreen.title": {
    "defaultMessage": "Matches"
  },
  "audit.mediaPlayer.viewMedia": {
    "defaultMessage": "Play media"
  },
  "audit.missingAudios.emptyState.help": {
    "defaultMessage": "Lists material IDs for schedules in the selected range whose reference media was not uploaded for the linked station. Useful for finding schedules with no media to detect."
  },
  "audit.missingAudios.groupBy.custom_id": {
    "defaultMessage": "Custom ID"
  },
  "audit.missingAudios.groupBy.custom_id_station_id": {
    "defaultMessage": "Custom ID and station"
  },
  "audit.missingAudios.groupBy.none": {
    "defaultMessage": "No grouping"
  },
  "audit.missingAudios.scheduleDatetime": {
    "defaultMessage": "Schedule datetime"
  },
  "audit.missingAudios.title": {
    "defaultMessage": "Missing media"
  },
  "audit.missingAudios.viewScheduleBtn": {
    "defaultMessage": "View schedule"
  },
  "audit.noMatchesReport.emptyState.help": {
    "defaultMessage": "Shows media files uploaded in the selected range for which no match was detected in that range or in the other adjusted range."
  },
  "audit.notEnabled.htmlTitle": {
    "defaultMessage": "{stationName} - Audit not enabled"
  },
  "audit.notEnabledForStation.body": {
    "defaultMessage": "Contact us to enable Audit for {stationName}."
  },
  "audit.notEnabledForStation.title": {
    "defaultMessage": "This feature is not enabled for this station"
  },
  "audit.preview.generating": {
    "defaultMessage": "Generating..."
  },
  "audit.preview.preview": {
    "defaultMessage": "Preview"
  },
  "audit.preview.previewCsv": {
    "defaultMessage": "CSV preview"
  },
  "audit.preview.previewXls": {
    "defaultMessage": "XLS preview"
  },
  "audit.props.advertiser": {
    "defaultMessage": "Advertiser"
  },
  "audit.props.audioDuration": {
    "defaultMessage": "Media duration"
  },
  "audit.props.campaign": {
    "defaultMessage": "Campaign"
  },
  "audit.props.creationRange": {
    "defaultMessage": "Media creation date range"
  },
  "audit.props.customId": {
    "defaultMessage": "Custom ID"
  },
  "audit.props.datetime": {
    "defaultMessage": "Target datetime"
  },
  "audit.props.duration": {
    "defaultMessage": "Played duration"
  },
  "audit.props.manualMatch": {
    "defaultMessage": "Manual match"
  },
  "audit.props.matches": {
    "defaultMessage": "Matches"
  },
  "audit.props.mentionId": {
    "defaultMessage": "Mention ID"
  },
  "audit.props.order": {
    "defaultMessage": "Order"
  },
  "audit.props.score": {
    "defaultMessage": "Score"
  },
  "audit.props.time": {
    "defaultMessage": "Time"
  },
  "audit.props.tolerance": {
    "defaultMessage": "Tolerance"
  },
  "audit.props.tolerance.help": {
    "defaultMessage": "Values are in minutes. Format: minutes before / minutes after the scheduled date and time."
  },
  "audit.props.type": {
    "defaultMessage": "Type"
  },
  "audit.props.version": {
    "defaultMessage": "Version"
  },
  "audit.report.created": {
    "defaultMessage": "Created"
  },
  "audit.report.name": {
    "defaultMessage": "Name"
  },
  "audit.reportDefinitionEditor.columnLabel": {
    "defaultMessage": "Title"
  },
  "audit.reportDefinitionEditor.columnType.boolean": {
    "defaultMessage": "Boolean"
  },
  "audit.reportDefinitionEditor.columnType.boolean.falseLabel": {
    "defaultMessage": "Label for false"
  },
  "audit.reportDefinitionEditor.columnType.boolean.trueLabel": {
    "defaultMessage": "Label for true"
  },
  "audit.reportDefinitionEditor.columnType.date": {
    "defaultMessage": "Date"
  },
  "audit.reportDefinitionEditor.columnType.date.format": {
    "defaultMessage": "Date format"
  },
  "audit.reportDefinitionEditor.columnType.datetime": {
    "defaultMessage": "Date and time"
  },
  "audit.reportDefinitionEditor.columnType.datetime.format": {
    "defaultMessage": "Date and time format"
  },
  "audit.reportDefinitionEditor.columnType.number": {
    "defaultMessage": "Number"
  },
  "audit.reportDefinitionEditor.columnType.string": {
    "defaultMessage": "String"
  },
  "audit.reportDefinitionEditor.columnType.string.case": {
    "defaultMessage": "Text format"
  },
  "audit.reportDefinitionEditor.columnType.string.case.lowercase": {
    "defaultMessage": "Lowercase"
  },
  "audit.reportDefinitionEditor.columnType.string.case.none": {
    "defaultMessage": "No format"
  },
  "audit.reportDefinitionEditor.columnType.string.case.title": {
    "defaultMessage": "Title case"
  },
  "audit.reportDefinitionEditor.columnType.string.case.uppercase": {
    "defaultMessage": "Uppercase"
  },
  "audit.reportDefinitionEditor.columnType.time": {
    "defaultMessage": "Time"
  },
  "audit.reportDefinitionEditor.columnType.time.format": {
    "defaultMessage": "Time format"
  },
  "audit.reportDefinitionEditor.columnType.unknown": {
    "defaultMessage": "Unknown"
  },
  "audit.reportDefinitionEditor.columnType.url": {
    "defaultMessage": "URL"
  },
  "audit.reportDefinitionEditor.metadata.default": {
    "defaultMessage": "Default template"
  },
  "audit.reportDefinitionEditor.metadata.name": {
    "defaultMessage": "Name"
  },
  "audit.reportDefinitionEditor.metadata.name.helper": {
    "defaultMessage": "Name to identify this template"
  },
  "audit.reportDefinitionEditor.metadata.title": {
    "defaultMessage": "Information"
  },
  "audit.reportDefinitionEditor.title": {
    "defaultMessage": "Report template"
  },
  "audit.reportDefinitionList.actions": {
    "defaultMessage": "Actions"
  },
  "audit.reportDefinitionList.createdAt": {
    "defaultMessage": "Created"
  },
  "audit.reportDefinitionList.defaultTemplate": {
    "defaultMessage": "Default template"
  },
  "audit.reportDefinitionList.editTooltip": {
    "defaultMessage": "Edit"
  },
  "audit.reportDefinitionList.name": {
    "defaultMessage": "Name"
  },
  "audit.reportDefinitionList.nameFilterPlaceholder": {
    "defaultMessage": "Search by name"
  },
  "audit.reportDefinitionList.title": {
    "defaultMessage": "Report templates"
  },
  "audit.reportDefinitions.availableColumns.empty": {
    "defaultMessage": "No columns available"
  },
  "audit.reportDefinitions.cannotDeleteDefault": {
    "defaultMessage": "Default template cannot be deleted"
  },
  "audit.reportDefinitions.cloneButton": {
    "defaultMessage": "Clone"
  },
  "audit.reportDefinitions.cloneError": {
    "defaultMessage": "Error cloning template"
  },
  "audit.reportDefinitions.cloneSuccess": {
    "defaultMessage": "Template cloned successfully"
  },
  "audit.reportDefinitions.createError": {
    "defaultMessage": "Error creating template"
  },
  "audit.reportDefinitions.deleteError": {
    "defaultMessage": "Error deleting template"
  },
  "audit.reportDefinitions.deleteSuccess": {
    "defaultMessage": "Template deleted successfully"
  },
  "audit.reportDefinitions.deleteTemplateConfirm": {
    "defaultMessage": "Are you sure you want to delete the template \"{name}\"? This action cannot be undone."
  },
  "audit.reportDefinitions.deleteTemplateTitle": {
    "defaultMessage": "Delete template"
  },
  "audit.reportDefinitions.loadCustomLogo": {
    "defaultMessage": "Load custom logo"
  },
  "audit.reportDefinitions.newTemplateButton": {
    "defaultMessage": "New template"
  },
  "audit.reportDefinitions.previewError": {
    "defaultMessage": "Error generating preview"
  },
  "audit.reportDefinitions.reportTemplateTitle": {
    "defaultMessage": "Report template"
  },
  "audit.reportDefinitions.reportTypeRequired": {
    "defaultMessage": "Report type is required"
  },
  "audit.reportDefinitions.saveError": {
    "defaultMessage": "Error saving report template"
  },
  "audit.reportDefinitions.saveSuccess": {
    "defaultMessage": "Report template saved successfully"
  },
  "audit.reportDefinitions.segmentation.groupBy": {
    "defaultMessage": "Column"
  },
  "audit.reportDefinitions.segmentation.grouping": {
    "defaultMessage": "Segmentation"
  },
  "audit.reportDefinitions.segmentation.helperText": {
    "defaultMessage": "In XLS files a sheet will be generated for each value of the selected field. In CSV files a separate file will be generated inside a .zip"
  },
  "audit.reportDefinitions.segmentation.hideColumn": {
    "defaultMessage": "Hide this column in the report"
  },
  "audit.reportDefinitions.segmentation.noColumns": {
    "defaultMessage": "You must select at least one column to be able to group."
  },
  "audit.reportDefinitions.segmentation.removedNotification": {
    "defaultMessage": "Segmentation has been disabled because the associated column was removed."
  },
  "audit.reportDefinitions.segmentation.splitReport": {
    "defaultMessage": "Split into sections for one of the columns"
  },
  "audit.reportDefinitions.segmentation.tour.description": {
    "defaultMessage": "Enable this option to split the report into sections (e.g. one XLS sheet per value of the chosen column)."
  },
  "audit.reportDefinitions.segmentation.tour.title": {
    "defaultMessage": "Report segmentation"
  },
  "audit.reportDefinitions.selectedColumns.empty": {
    "defaultMessage": "No columns selected. Use the arrow button on available columns to add them."
  },
  "audit.reportDefinitions.sorting.noRules": {
    "defaultMessage": "No sort rules. Click \"Add order\" to add one."
  },
  "audit.reportDefinitions.sorting.order": {
    "defaultMessage": "Order"
  },
  "audit.reportDefinitions.styleTitle": {
    "defaultMessage": "Style"
  },
  "audit.reportDefinitions.templatesForReport": {
    "defaultMessage": "Templates for report {name}"
  },
  "audit.reportDefinitions.templatesTitle": {
    "defaultMessage": "Templates"
  },
  "audit.reportDefinitions.useClientLogo": {
    "defaultMessage": "Use client logo"
  },
  "audit.reportDelete.deleted": {
    "defaultMessage": "Report deleted"
  },
  "audit.reportDelete.deleteError": {
    "defaultMessage": "Could not delete report"
  },
  "audit.reportDelete.prompt": {
    "defaultMessage": "Do you want to delete this report? {br} This action can not be undone."
  },
  "audit.reportDelete.title": {
    "defaultMessage": "Delete report"
  },
  "audit.reportNames.AUDIT_BROADCAST_EVIDENCE": {
    "defaultMessage": "Broadcast Evidence"
  },
  "audit.reportNames.AUDIT_GIP_ALTERNATIVE_REPORT": {
    "defaultMessage": "GIP alternative"
  },
  "audit.reportNames.AUDIT_GIP_STATUS": {
    "defaultMessage": "GIP"
  },
  "audit.reportNames.BCR_MATCHES": {
    "defaultMessage": "BCR Matches"
  },
  "audit.reports.bcrMatches.noBcrEntries": {
    "defaultMessage": "No BCR entries found for the report"
  },
  "audit.reports.branding.logo": {
    "defaultMessage": "Logo"
  },
  "audit.reports.ltxMatches.noLtxEntries": {
    "defaultMessage": "No LTX entries found for the report"
  },
  "audit.reports.section.availableColumns": {
    "defaultMessage": "Available columns"
  },
  "audit.reports.section.reportColumns": {
    "defaultMessage": "Report columns"
  },
  "audit.reports.sorting.add": {
    "defaultMessage": "Add"
  },
  "audit.reports.viewNotFound": {
    "defaultMessage": "View not found for report {type}"
  },
  "audit.reportsList.createdBy": {
    "defaultMessage": "Created by"
  },
  "audit.reportsList.exportStatus": {
    "defaultMessage": "Export status"
  },
  "audit.reportsList.noExport": {
    "defaultMessage": "No export"
  },
  "audit.reportsList.onlyMine": {
    "defaultMessage": "Only mine"
  },
  "audit.reportsList.title": {
    "defaultMessage": "Created reports"
  },
  "audit.reportsScreen.bcrMatches.customId": {
    "defaultMessage": "Custom ID (optional)"
  },
  "audit.reportsScreen.bcrMatches.date": {
    "defaultMessage": "Date"
  },
  "audit.reportsScreen.bcrMatches.noSchedule": {
    "defaultMessage": "No schedule"
  },
  "audit.reportsScreen.bcrMatches.tabs.unverifiedBcrEntries": {
    "defaultMessage": "Unverified BCR entries"
  },
  "audit.reportsScreen.bcrMatches.tabs.unverifiedMatches": {
    "defaultMessage": "Unverified matches"
  },
  "audit.reportsScreen.bcrMatches.tabs.verified": {
    "defaultMessage": "Verified matches"
  },
  "audit.reportsScreen.bcrMatches.title": {
    "defaultMessage": "BCR Matches"
  },
  "audit.reportsScreen.bcrMatches.unverifiedBcrEntries.name": {
    "defaultMessage": "Name"
  },
  "audit.reportsScreen.bcrMatches.verified.bcrEntryDatetime": {
    "defaultMessage": "BCR entry time"
  },
  "audit.reportsScreen.bcrMatches.verified.bcrName": {
    "defaultMessage": "BCR name"
  },
  "audit.reportsScreen.bcrMatches.verified.matchedSchedule": {
    "defaultMessage": "Schedule"
  },
  "audit.reportsScreen.equalMd5.title": {
    "defaultMessage": "Media with same content"
  },
  "audit.reportsScreen.ltxMatches.customId": {
    "defaultMessage": "Custom ID (optional)"
  },
  "audit.reportsScreen.ltxMatches.date": {
    "defaultMessage": "Date"
  },
  "audit.reportsScreen.ltxMatches.noSchedule": {
    "defaultMessage": "No schedule"
  },
  "audit.reportsScreen.ltxMatches.tabs.unverifiedLtxEntries": {
    "defaultMessage": "Unverified LTX entries"
  },
  "audit.reportsScreen.ltxMatches.tabs.unverifiedMatches": {
    "defaultMessage": "Unverified matches"
  },
  "audit.reportsScreen.ltxMatches.tabs.verified": {
    "defaultMessage": "Verified matches"
  },
  "audit.reportsScreen.ltxMatches.title": {
    "defaultMessage": "LTX Matches"
  },
  "audit.reportsScreen.ltxMatches.unverifiedLtxEntries.name": {
    "defaultMessage": "Name"
  },
  "audit.reportsScreen.ltxMatches.unverifiedLtxEntries.type": {
    "defaultMessage": "Type"
  },
  "audit.reportsScreen.ltxMatches.verified.ltxEntryDatetime": {
    "defaultMessage": "LTX entry time"
  },
  "audit.reportsScreen.ltxMatches.verified.ltxName": {
    "defaultMessage": "LTX name"
  },
  "audit.reportsScreen.ltxMatches.verified.matchedSchedule": {
    "defaultMessage": "Schedule"
  },
  "audit.reportsScreen.missingAudios.datetime": {
    "defaultMessage": "Date and time"
  },
  "audit.reportsScreen.missingAudios.title": {
    "defaultMessage": "Missing media"
  },
  "audit.reportsScreen.missingAudios.viewScheduleBtn": {
    "defaultMessage": "View schedule detail"
  },
  "audit.reportsScreen.noMatches.creationRange": {
    "defaultMessage": "Creation range"
  },
  "audit.reportsScreen.noMatches.matchRange": {
    "defaultMessage": "Match range"
  },
  "audit.reportsScreen.noMatches.sameAudioMatch.matchesLink": {
    "defaultMessage": "View {audioId} matches"
  },
  "audit.reportsScreen.noMatches.sameAudioMatch.message": {
    "defaultMessage": "There is an equal-content media with matches:"
  },
  "audit.reportsScreen.noMatches.title": {
    "defaultMessage": "Media without matches"
  },
  "audit.reportsScreen.noMatches.useSameRangeLabel": {
    "defaultMessage": "Use same media creation range"
  },
  "audit.reportsScreen.title": {
    "defaultMessage": "Reports"
  },
  "audit.reportsView.cloneBtn": {
    "defaultMessage": "Clone"
  },
  "audit.reportsView.created": {
    "defaultMessage": "Created"
  },
  "audit.reportsView.createdBy": {
    "defaultMessage": "Created by"
  },
  "audit.reportsView.createdByUnknown": {
    "defaultMessage": "Created by unknown"
  },
  "audit.reportsView.export": {
    "defaultMessage": "Export"
  },
  "audit.reportsView.exportBtn": {
    "defaultMessage": "Download report"
  },
  "audit.reportsView.exportDialog.confirm": {
    "defaultMessage": "Download"
  },
  "audit.reportsView.exportDialog.format": {
    "defaultMessage": "Format"
  },
  "audit.reportsView.exportDialog.noDefinitions": {
    "defaultMessage": "No templates available"
  },
  "audit.reportsView.exportDialog.title": {
    "defaultMessage": "Download report"
  },
  "audit.reportsView.exportFailed": {
    "defaultMessage": "Export failed"
  },
  "audit.reportsView.exportInfo": {
    "defaultMessage": "Export configuration"
  },
  "audit.reportsView.name": {
    "defaultMessage": "Name"
  },
  "audit.reportsView.type": {
    "defaultMessage": "Type"
  },
  "audit.schedulesList.matchDatetime": {
    "defaultMessage": "Match"
  },
  "audit.schedulesList.mentions.diffLabel": {
    "defaultMessage": "Diff"
  },
  "audit.schedulesListScreen.inheritedTolerance": {
    "defaultMessage": "Inherited tolerance"
  },
  "audit.schedulesListScreen.noAudio": {
    "defaultMessage": "No media"
  },
  "audit.schedulesListScreen.noMatch": {
    "defaultMessage": "No match"
  },
  "audit.schedulesListScreen.props.status": {
    "defaultMessage": "Status"
  },
  "audit.schedulesListScreen.title": {
    "defaultMessage": "Schedules"
  },
  "audit.schedulesListScreen.viewScheduleBtn": {
    "defaultMessage": "View detail"
  },
  "audit.schedulesNoMatches.includeMissingAudio": {
    "defaultMessage": "Include missing media"
  },
  "audit.schedulesNoMatches.title": {
    "defaultMessage": "Schedules without matches"
  },
  "audit.schedulesPreview.advertiser": {
    "defaultMessage": "Advertiser"
  },
  "audit.schedulesPreview.campaign": {
    "defaultMessage": "Campaign"
  },
  "audit.schedulesPreview.dateTime": {
    "defaultMessage": "Date/time"
  },
  "audit.schedulesPreview.tolerance": {
    "defaultMessage": "Tolerance"
  },
  "audit.schedulesPreview.version": {
    "defaultMessage": "Version"
  },
  "audit.scheduleStatusPntScreen.confidence": {
    "defaultMessage": "Confidence"
  },
  "audit.scheduleStatusPntScreen.status.help": {
    "defaultMessage": "Numbers are matches with schedule / schedules.\n\nComplete: every schedule has a match.\nPartial: not every schedule has a match.\nNot aired: there are schedules and no matches.\nNo matches: there are no matches and no schedules.\n\nThe warning icon means at least one match is off tolerance."
  },
  "audit.scheduleStatusScreen.detailModal.matchDatetime": {
    "defaultMessage": "Match date and time"
  },
  "audit.scheduleStatusScreen.detailModal.matchedSchedule": {
    "defaultMessage": "Matched schedule"
  },
  "audit.scheduleStatusScreen.detailModal.matches": {
    "defaultMessage": "Confirmed match"
  },
  "audit.scheduleStatusScreen.detailModal.noMatchedSchedule": {
    "defaultMessage": "No schedule"
  },
  "audit.scheduleStatusScreen.detailModal.offTolerance": {
    "defaultMessage": "Off tolerance"
  },
  "audit.scheduleStatusScreen.detailModal.schedules": {
    "defaultMessage": "Schedules"
  },
  "audit.scheduleStatusScreen.detailModal.unmatchedMatches": {
    "defaultMessage": "Matches without schedule"
  },
  "audit.scheduleStatusScreen.filter.idPlaceholder": {
    "defaultMessage": "All"
  },
  "audit.scheduleStatusScreen.noAudio": {
    "defaultMessage": "No media"
  },
  "audit.scheduleStatusScreen.overview.all": {
    "defaultMessage": "All"
  },
  "audit.scheduleStatusScreen.status": {
    "defaultMessage": "Status"
  },
  "audit.scheduleStatusScreen.status.chipTooltip": {
    "defaultMessage": "{matchesCount} matches / {matchesWithScheduleCount} with schedule / {schedulesCount} schedules"
  },
  "audit.scheduleStatusScreen.status.chipTooltipOffTolerance": {
    "defaultMessage": "{matchesCount} matches / {matchesWithScheduleCount} with schedule / {schedulesCount} schedules ({offToleranceCount} off tolerance)"
  },
  "audit.scheduleStatusScreen.status.complete": {
    "defaultMessage": "Complete"
  },
  "audit.scheduleStatusScreen.status.help": {
    "defaultMessage": "Numbers are matches with schedule / schedules.\n\nComplete: every schedule has a match.\nPartial: not every schedule has a match.\nNot aired: there are schedules and no matches.\nNo matches: there are no matches and no schedules.\n\nThe warning icon means at least one match is off tolerance."
  },
  "audit.scheduleStatusScreen.status.missingEmission": {
    "defaultMessage": "Not aired"
  },
  "audit.scheduleStatusScreen.status.none": {
    "defaultMessage": "No matches"
  },
  "audit.scheduleStatusScreen.status.offTolerance": {
    "defaultMessage": "Off tolerance"
  },
  "audit.scheduleStatusScreen.status.partial": {
    "defaultMessage": "Partial"
  },
  "audit.scheduleStatusScreen.title": {
    "defaultMessage": "Schedule"
  },
  "audit.schedulesViewScreen.loading": {
    "defaultMessage": "Loading schedule"
  },
  "audit.schedulesViewScreen.matchDiff": {
    "defaultMessage": "Difference (minutes)"
  },
  "audit.schedulesViewScreen.matchesCount": {
    "defaultMessage": "{count, plural, =0 {No results found for the date} one {1 match found} other {# matches found} }"
  },
  "audit.schedulesViewScreen.matchTime": {
    "defaultMessage": "Date and time"
  },
  "audit.schedulesViewScreen.title": {
    "defaultMessage": "Schedule #{id}"
  },
  "audit.screenbug.title": {
    "defaultMessage": "Screenbug"
  },
  "audit.sidenav.aod": {
    "defaultMessage": "AOD"
  },
  "audit.sidenav.config": {
    "defaultMessage": "Config"
  },
  "audit.sidenav.globalReports": {
    "defaultMessage": "General audit"
  },
  "audit.sidenav.stationAudit": {
    "defaultMessage": "Station audit"
  },
  "audit.sorting.ascending": {
    "defaultMessage": "Ascending"
  },
  "audit.sorting.descending": {
    "defaultMessage": "Descending"
  },
  "audit.streamScreen.adoverlay": {
    "defaultMessage": "Ad Overlay"
  },
  "audit.streamScreen.audioMatches": {
    "defaultMessage": "Media Matches"
  },
  "audit.streamScreen.liveMentions": {
    "defaultMessage": "Live Mentions"
  },
  "audit.streamScreen.lowerthird": {
    "defaultMessage": "Lowerthird"
  },
  "audit.streamScreen.transcriptions": {
    "defaultMessage": "Transcriptions"
  },
  "audit.title": {
    "defaultMessage": "Audit"
  },
  "audit.transcriptionScreen.confidence": {
    "defaultMessage": "Confidence"
  },
  "audit.transcriptionScreen.high": {
    "defaultMessage": "High"
  },
  "audit.transcriptionScreen.loading": {
    "defaultMessage": "Loading transcriptions"
  },
  "audit.transcriptionScreen.low": {
    "defaultMessage": "Low"
  },
  "audit.transcriptionScreen.medium": {
    "defaultMessage": "Medium"
  },
  "audit.transcriptionScreen.music": {
    "defaultMessage": "[Music / Silence]"
  },
  "audit.transcriptionScreen.noResults": {
    "defaultMessage": "No transcriptions found"
  },
  "audit.transcriptionScreen.sentence": {
    "defaultMessage": "Sentence"
  },
  "audit.transcriptionScreen.speakers": {
    "defaultMessage": "Speaker Labels"
  },
  "audit.uploadScreen.item.code": {
    "defaultMessage": "(Error code: {code})"
  },
  "audit.uploadScreen.item.completed": {
    "defaultMessage": "Successfully uploaded"
  },
  "audit.uploadScreen.item.error": {
    "defaultMessage": "Error: {message}"
  },
  "audit.uploadScreen.item.notStarted": {
    "defaultMessage": "Not uploaded"
  },
  "audit.uploadScreen.item.overridden": {
    "defaultMessage": "(previous media version was updated)"
  },
  "audit.uploadScreen.item.remove": {
    "defaultMessage": "Remove"
  },
  "audit.uploadScreen.item.started": {
    "defaultMessage": "Uploading"
  },
  "audit.uploadScreen.item.status": {
    "defaultMessage": "Status:"
  },
  "audit.uploadScreen.leavePrompt": {
    "defaultMessage": "There is one or more uploads in progress. Are you sure you want to leave the page?"
  },
  "audit.uploadScreen.reset": {
    "defaultMessage": "Reset"
  },
  "audit.uploadScreen.selectedCount": {
    "defaultMessage": "{count, plural, one {1 selected file} other {# selected files} }"
  },
  "audit.uploadScreen.title": {
    "defaultMessage": "Upload files"
  },
  "audit.uploadScreen.upload": {
    "defaultMessage": "Upload"
  },
  "audit.verifyMatch.accept": {
    "defaultMessage": "Accept"
  },
  "audit.verifyMatch.actionTitle": {
    "defaultMessage": "Verify detection"
  },
  "audit.verifyMatch.broadcastTitle": {
    "defaultMessage": "Detected broadcast"
  },
  "audit.verifyMatch.creativeTitle": {
    "defaultMessage": "Reference media"
  },
  "audit.verifyMatch.dialogTitle": {
    "defaultMessage": "Verify detection"
  },
  "audit.verifyMatch.mentionContentTitle": {
    "defaultMessage": "Mention content"
  },
  "audit.verifyMatch.navigationPosition": {
    "defaultMessage": "{current} / {total}"
  },
  "audit.verifyMatch.next": {
    "defaultMessage": "Next"
  },
  "audit.verifyMatch.noMentionContent": {
    "defaultMessage": "No mention content available for this detection."
  },
  "audit.verifyMatch.noScheduleConfirmation": {
    "defaultMessage": "No confirmation"
  },
  "audit.verifyMatch.noTranscription": {
    "defaultMessage": "No transcription available for this media."
  },
  "audit.verifyMatch.previous": {
    "defaultMessage": "Previous"
  },
  "audit.verifyMatch.reject": {
    "defaultMessage": "Reject"
  },
  "audit.verifyMatch.transcriptionTitle": {
    "defaultMessage": "Media transcription"
  },
  "auth.errors.ERR_AUTH_FAILED": {
    "defaultMessage": "Please try again or contact support."
  },
  "auth.errors.ERR_USER_NOT_REGISTERED": {
    "defaultMessage": "User is not registered on the platform, please contact support."
  },
  "auth.loginScreen.errorTitle": {
    "defaultMessage": "Could not sign in"
  },
  "auth.loginScreen.loginBtn": {
    "defaultMessage": "Login"
  },
  "auth.loginScreen.title": {
    "defaultMessage": "Login"
  },
  "auth.noPermissionForPage": {
    "defaultMessage": "You don't have permission to access this page"
  },
  "auth.tokenGate.errorLabel": {
    "defaultMessage": "Auth error:"
  },
  "auth.userInfo.changeUser": {
    "defaultMessage": "Change user"
  },
  "common.action.clear": {
    "defaultMessage": "Clear"
  },
  "common.actions": {
    "defaultMessage": "Actions"
  },
  "common.actions.back": {
    "defaultMessage": "Back"
  },
  "common.actions.cancel": {
    "defaultMessage": "Cancel"
  },
  "common.actions.clone": {
    "defaultMessage": "Clone"
  },
  "common.actions.create": {
    "defaultMessage": "Create new"
  },
  "common.actions.createEntity": {
    "defaultMessage": "Create"
  },
  "common.actions.delete": {
    "defaultMessage": "Delete"
  },
  "common.actions.discard": {
    "defaultMessage": "Discard"
  },
  "common.actions.draft": {
    "defaultMessage": "Draft"
  },
  "common.actions.edit": {
    "defaultMessage": "Edit"
  },
  "common.actions.export": {
    "defaultMessage": "Export"
  },
  "common.actions.exportAsCsv": {
    "defaultMessage": "Export as CSV"
  },
  "common.actions.exportAsXls": {
    "defaultMessage": "Export as XLS"
  },
  "common.actions.filterByValue": {
    "defaultMessage": "Filter by this value"
  },
  "common.actions.refresh": {
    "defaultMessage": "Refresh"
  },
  "common.actions.resetFilters": {
    "defaultMessage": "Clear"
  },
  "common.actions.save": {
    "defaultMessage": "Save"
  },
  "common.actions.select": {
    "defaultMessage": "Select..."
  },
  "common.actions.selectAll": {
    "defaultMessage": "Select all"
  },
  "common.actions.selectNone": {
    "defaultMessage": "Deselect all"
  },
  "common.allStations": {
    "defaultMessage": "All stations"
  },
  "common.audio": {
    "defaultMessage": "audio"
  },
  "common.breadcrumb": {
    "defaultMessage": "Breadcrumb"
  },
  "common.cancel": {
    "defaultMessage": "Cancel"
  },
  "common.clear": {
    "defaultMessage": "Clear"
  },
  "common.close": {
    "defaultMessage": "Close"
  },
  "common.columnIndex": {
    "defaultMessage": "#"
  },
  "common.confirm": {
    "defaultMessage": "Confirm"
  },
  "common.createdAt": {
    "defaultMessage": "Created at"
  },
  "common.customId": {
    "defaultMessage": "Custom ID"
  },
  "common.customImage": {
    "defaultMessage": "Custom image"
  },
  "common.date": {
    "defaultMessage": "Date"
  },
  "common.dateEnd": {
    "defaultMessage": "End date"
  },
  "common.dateRangeSelector.apply": {
    "defaultMessage": "Apply"
  },
  "common.dateRangeSelector.labelToNow": {
    "defaultMessage": "{from} to now"
  },
  "common.dateRangeSelector.preset.customFixedDateRange": {
    "defaultMessage": "Custom fixed date range..."
  },
  "common.dateRangeSelector.preset.customSingleDate": {
    "defaultMessage": "Custom date..."
  },
  "common.dateRangeSelector.preset.fromCustomDateUntilNow": {
    "defaultMessage": "From custom date until now..."
  },
  "common.dateRangeSelector.preset.last14Days": {
    "defaultMessage": "Last 14 days"
  },
  "common.dateRangeSelector.preset.last180Days": {
    "defaultMessage": "Last 180 days"
  },
  "common.dateRangeSelector.preset.last24Hours": {
    "defaultMessage": "Last 24 hours"
  },
  "common.dateRangeSelector.preset.last30Days": {
    "defaultMessage": "Last 30 days"
  },
  "common.dateRangeSelector.preset.last7Days": {
    "defaultMessage": "Last 7 days"
  },
  "common.dateRangeSelector.preset.last90Days": {
    "defaultMessage": "Last 90 days"
  },
  "common.dateRangeSelector.preset.lastHour": {
    "defaultMessage": "Last hour"
  },
  "common.dateRangeSelector.preset.lastMonth": {
    "defaultMessage": "Last month"
  },
  "common.dateRangeSelector.preset.lastNHours": {
    "defaultMessage": "Last {hours} hours"
  },
  "common.dateRangeSelector.preset.lastWeek": {
    "defaultMessage": "Last week"
  },
  "common.dateRangeSelector.preset.thisMonth": {
    "defaultMessage": "This month"
  },
  "common.dateRangeSelector.preset.thisWeek": {
    "defaultMessage": "This week"
  },
  "common.dateRangeSelector.preset.today": {
    "defaultMessage": "Today"
  },
  "common.dateRangeSelector.preset.yearToDate": {
    "defaultMessage": "Year to date"
  },
  "common.dateRangeSelector.preset.yesterday": {
    "defaultMessage": "Yesterday"
  },
  "common.dateRangeSelector.selectDateRangeTitle": {
    "defaultMessage": "Select a date range"
  },
  "common.dateRangeSelector.selectedLabel": {
    "defaultMessage": "Selected: {from} – {to}"
  },
  "common.dateSelector.preset.dayMinus2": {
    "defaultMessage": ""
  },
  "common.dateSelector.preset.dayMinus3": {
    "defaultMessage": ""
  },
  "common.dateSelector.preset.dayMinus4": {
    "defaultMessage": ""
  },
  "common.dateSelector.preset.dayMinus5": {
    "defaultMessage": ""
  },
  "common.dateSelector.preset.dayMinus6": {
    "defaultMessage": ""
  },
  "common.dateSelector.preset.today": {
    "defaultMessage": "Today"
  },
  "common.dateSelector.preset.yesterday": {
    "defaultMessage": "Yesterday"
  },
  "common.dateSelector.selectDate": {
    "defaultMessage": "Select date"
  },
  "common.dateStart": {
    "defaultMessage": "Start date"
  },
  "common.datetime": {
    "defaultMessage": "Date and time"
  },
  "common.datetimeRange": {
    "defaultMessage": "Date range"
  },
  "common.delete": {
    "defaultMessage": "Delete"
  },
  "common.disabled": {
    "defaultMessage": "Disabled"
  },
  "common.download": {
    "defaultMessage": "Download"
  },
  "common.edit": {
    "defaultMessage": "Edit"
  },
  "common.email": {
    "defaultMessage": "Email"
  },
  "common.enabled": {
    "defaultMessage": "Enabled"
  },
  "common.entities.fragments": {
    "defaultMessage": "fragments"
  },
  "common.entities.group": {
    "defaultMessage": "Group"
  },
  "common.entities.groups": {
    "defaultMessage": "groups"
  },
  "common.entities.station": {
    "defaultMessage": "Station"
  },
  "common.entities.stations": {
    "defaultMessage": "Stations"
  },
  "common.entities.user": {
    "defaultMessage": "user"
  },
  "common.error": {
    "defaultMessage": "An error occurred, please try again"
  },
  "common.errorOccurredTryAgain": {
    "defaultMessage": "An error occurred, please try again"
  },
  "common.form.errorNotification": {
    "defaultMessage": "An error occurred. Please check all fields and try again. If the error persists, contact support"
  },
  "common.form.saveBtnText": {
    "defaultMessage": "Save"
  },
  "common.frameSelector.frameSelected": {
    "defaultMessage": "Frame selected:"
  },
  "common.frameSelector.useThisFrame": {
    "defaultMessage": "Use this frame"
  },
  "common.groupBy": {
    "defaultMessage": "Group by"
  },
  "common.help": {
    "defaultMessage": "Help"
  },
  "common.insertContentHere": {
    "defaultMessage": "Insert content here"
  },
  "common.jobFailed": {
    "defaultMessage": "Job failed"
  },
  "common.jobInProgress": {
    "defaultMessage": "Job in progress"
  },
  "common.jobStatus.CANCELLED": {
    "defaultMessage": "Canceled"
  },
  "common.jobStatus.COMPLETED": {
    "defaultMessage": "Completed"
  },
  "common.jobStatus.FAILED": {
    "defaultMessage": "Failed"
  },
  "common.jobStatus.IN_PROGRESS": {
    "defaultMessage": "In progress"
  },
  "common.jobStatus.SCHEDULED": {
    "defaultMessage": "Scheduled"
  },
  "common.jobStatus.WAITING": {
    "defaultMessage": "Queued"
  },
  "common.languageSelect.defaultLabel": {
    "defaultMessage": "Language"
  },
  "common.listView.clearAllFilters": {
    "defaultMessage": "Clear all filters"
  },
  "common.listView.noMoreResults": {
    "defaultMessage": "No more results"
  },
  "common.listView.noResults": {
    "defaultMessage": "No results"
  },
  "common.listView.totalResults": {
    "defaultMessage": "{count, number} results"
  },
  "common.listView.tryOtherFiltersOrClear": {
    "defaultMessage": "Try searching with other filters or clear the applied ones to see more results."
  },
  "common.listView.useFiltersToFindMore": {
    "defaultMessage": "Use filters to find more results"
  },
  "common.loadFile": {
    "defaultMessage": "Load file"
  },
  "common.loadImage": {
    "defaultMessage": "Load image"
  },
  "common.loading": {
    "defaultMessage": "Loading..."
  },
  "common.loadingEntity": {
    "defaultMessage": "Loading entity"
  },
  "common.loadMore": {
    "defaultMessage": "Show earlier"
  },
  "common.loadThumbnail": {
    "defaultMessage": "Load thumbnail"
  },
  "common.name": {
    "defaultMessage": "Name"
  },
  "common.no": {
    "defaultMessage": "No"
  },
  "common.noOptions": {
    "defaultMessage": "No results found"
  },
  "common.noResults": {
    "defaultMessage": "No results"
  },
  "common.noStations.message": {
    "defaultMessage": "This page will update automatically when they become available."
  },
  "common.noStations.title": {
    "defaultMessage": "No stations assigned yet"
  },
  "common.notes": {
    "defaultMessage": "Notes"
  },
  "common.notifications.deleted": {
    "defaultMessage": "Successfully deleted"
  },
  "common.notifications.deleteError": {
    "defaultMessage": "Delete error"
  },
  "common.notifications.updated": {
    "defaultMessage": "{entity} updated"
  },
  "common.optional": {
    "defaultMessage": "(optional)"
  },
  "common.pause": {
    "defaultMessage": "Pause"
  },
  "common.play": {
    "defaultMessage": "Play"
  },
  "common.prose.showLess": {
    "defaultMessage": "Show less"
  },
  "common.prose.showMore": {
    "defaultMessage": "Show more"
  },
  "common.quantity": {
    "defaultMessage": "Quantity"
  },
  "common.refresh": {
    "defaultMessage": "Refresh"
  },
  "common.remove": {
    "defaultMessage": "Remove"
  },
  "common.removeFilter": {
    "defaultMessage": "Remove filter"
  },
  "common.required": {
    "defaultMessage": "Required"
  },
  "common.routeNotFound.help": {
    "defaultMessage": "The link may be broken or the page may have moved."
  },
  "common.routeNotFound.title": {
    "defaultMessage": "This page doesn't exist"
  },
  "common.selectFileLabel": {
    "defaultMessage": "Select file {extensions}"
  },
  "common.show": {
    "defaultMessage": "Show"
  },
  "common.simpleTableAriaLabel": {
    "defaultMessage": "Data table"
  },
  "common.station": {
    "defaultMessage": "Station"
  },
  "common.stationNotFound.help": {
    "defaultMessage": "It may not exist or you may not have access to it."
  },
  "common.stationNotFound.text": {
    "defaultMessage": "Station not found"
  },
  "common.stations": {
    "defaultMessage": "Stations"
  },
  "common.stations.shared.tooltip": {
    "defaultMessage": "External station"
  },
  "common.stations.type.AFFILIATE": {
    "defaultMessage": "Affiliate"
  },
  "common.stations.type.HEADER": {
    "defaultMessage": "Header"
  },
  "common.stations.type.REPEATER": {
    "defaultMessage": "Repeater"
  },
  "common.stations.type.STANDALONE": {
    "defaultMessage": "Standalone"
  },
  "common.stations.youtubeNative.tooltip": {
    "defaultMessage": "YouTube-native station"
  },
  "common.status": {
    "defaultMessage": "Status"
  },
  "common.status.active": {
    "defaultMessage": "Active"
  },
  "common.status.inactive": {
    "defaultMessage": "Inactive"
  },
  "common.text": {
    "defaultMessage": "Text"
  },
  "common.text.actions": {
    "defaultMessage": "Actions"
  },
  "common.text.addFilter": {
    "defaultMessage": "Filter"
  },
  "common.text.all": {
    "defaultMessage": "All"
  },
  "common.text.back": {
    "defaultMessage": "Back"
  },
  "common.text.content": {
    "defaultMessage": "Content"
  },
  "common.text.count": {
    "defaultMessage": "Count"
  },
  "common.text.date": {
    "defaultMessage": "Date"
  },
  "common.text.description": {
    "defaultMessage": "Description"
  },
  "common.text.duration": {
    "defaultMessage": "duration"
  },
  "common.text.language": {
    "defaultMessage": "Language"
  },
  "common.text.name": {
    "defaultMessage": "Name"
  },
  "common.text.next": {
    "defaultMessage": "Next"
  },
  "common.text.no": {
    "defaultMessage": "No"
  },
  "common.text.notSet": {
    "defaultMessage": "Not set"
  },
  "common.text.subtitle": {
    "defaultMessage": "Subtitle"
  },
  "common.text.time": {
    "defaultMessage": "Time"
  },
  "common.text.timezone": {
    "defaultMessage": "Timezone"
  },
  "common.text.title": {
    "defaultMessage": "Title"
  },
  "common.text.type": {
    "defaultMessage": "Type"
  },
  "common.text.yes": {
    "defaultMessage": "Yes"
  },
  "common.thumbnail": {
    "defaultMessage": "Thumbnail"
  },
  "common.thumbType": {
    "defaultMessage": "Thumbnail type"
  },
  "common.timeEnd": {
    "defaultMessage": "End time"
  },
  "common.timeStart": {
    "defaultMessage": "Start time"
  },
  "common.title": {
    "defaultMessage": "Title"
  },
  "common.truncate.hide": {
    "defaultMessage": "Hide"
  },
  "common.truncate.showAll": {
    "defaultMessage": "Show all"
  },
  "common.type": {
    "defaultMessage": "Type"
  },
  "common.updatedAt": {
    "defaultMessage": "Updated at"
  },
  "common.users": {
    "defaultMessage": "Users"
  },
  "common.video": {
    "defaultMessage": "video"
  },
  "common.videoFrame": {
    "defaultMessage": "Video frame"
  },
  "common.visualize": {
    "defaultMessage": "Visualize"
  },
  "common.wizard.back": {
    "defaultMessage": "Back"
  },
  "common.wizard.finish": {
    "defaultMessage": "Finish"
  },
  "common.wizard.next": {
    "defaultMessage": "Next"
  },
  "common.yes": {
    "defaultMessage": "Yes"
  },
  "compose.createComposition.action": {
    "defaultMessage": "Create composition"
  },
  "compose.createPage.fieldName": {
    "defaultMessage": "Name"
  },
  "compose.createPage.successToast": {
    "defaultMessage": "Composition created"
  },
  "compose.createPage.title": {
    "defaultMessage": "Create composition"
  },
  "compose.delete.message": {
    "defaultMessage": "Are you sure you want to delete the composition \"{name}\"? This action cannot be undone."
  },
  "compose.delete.successToast": {
    "defaultMessage": "Composition deleted"
  },
  "compose.delete.title": {
    "defaultMessage": "Delete composition"
  },
  "compose.editPage.successToast": {
    "defaultMessage": "Composition updated"
  },
  "compose.editPage.title": {
    "defaultMessage": "Edit composition"
  },
  "compose.filters.compositionName": {
    "defaultMessage": "Composition name"
  },
  "compose.listCard.editsCount": {
    "defaultMessage": "{count, plural, one {# edit} other {# edits}}"
  },
  "compose.listCard.unpublished": {
    "defaultMessage": "Unpublished"
  },
  "compose.listEmptyState.message": {
    "defaultMessage": "No compositions"
  },
  "compose.listScreen.hubLabel": {
    "defaultMessage": "Compose"
  },
  "compose.listScreen.title": {
    "defaultMessage": "Compose"
  },
  "compose.navTitle": {
    "defaultMessage": "Compose"
  },
  "compose.publish.tabTitle": {
    "defaultMessage": "Networks"
  },
  "compose.videoEditions.tabTitle": {
    "defaultMessage": "Edits"
  },
  "contentAi.articleNumber": {
    "defaultMessage": "ARTICLE {number}"
  },
  "contentAi.articles.generateContent": {
    "defaultMessage": "Generate content"
  },
  "contentAi.articles.instructions": {
    "defaultMessage": "Instructions"
  },
  "contentAi.backToArticleSelection": {
    "defaultMessage": "Back to article selection"
  },
  "contentAi.configPerStation": {
    "defaultMessage": "Config per station"
  },
  "contentAi.configTitle": {
    "defaultMessage": "Content AI config"
  },
  "contentAi.contentOrigin": {
    "defaultMessage": "Content origin:"
  },
  "contentAi.contentsList.fragment": {
    "defaultMessage": "Fragment"
  },
  "contentAi.contentsList.source": {
    "defaultMessage": "Source"
  },
  "contentAi.contentsList.title": {
    "defaultMessage": "Content AI - Contents"
  },
  "contentAi.contentsList.view": {
    "defaultMessage": "View"
  },
  "contentAi.copyToClipboard": {
    "defaultMessage": "Copy to clipboard"
  },
  "contentAi.externalExportEnabled": {
    "defaultMessage": "External export enabled"
  },
  "contentAi.fragment": {
    "defaultMessage": "Fragment"
  },
  "contentAi.fragmentContentExists": {
    "defaultMessage": "Content already exists for this fragment"
  },
  "contentAi.goToContent": {
    "defaultMessage": "Go to content"
  },
  "contentAi.instructionsOptional": {
    "defaultMessage": "Instructions (optional)"
  },
  "contentAi.instructionsPlaceholder": {
    "defaultMessage": "Enter the instructions here."
  },
  "contentAi.placeholder.tone": {
    "defaultMessage": "Positive, negative, neutral"
  },
  "contentAi.preparingMedia": {
    "defaultMessage": "Preparing media for analysis"
  },
  "contentAi.regenerateArticles": {
    "defaultMessage": "Regenerate articles"
  },
  "contentAi.saveAndContinue": {
    "defaultMessage": "Save and continue"
  },
  "contentAi.socialVersion.generatedFor": {
    "defaultMessage": "Content generated for {platform}"
  },
  "contentAi.socialVersion.generateFor": {
    "defaultMessage": "Generate content for {platform}"
  },
  "contentAi.socialVersion.publishContent": {
    "defaultMessage": "Publish content"
  },
  "contentAi.socialVersion.publishError": {
    "defaultMessage": "An error occurred while publishing the version, please try again"
  },
  "contentAi.socialVersion.regenerate": {
    "defaultMessage": "Regenerate"
  },
  "contentAi.stationConfig.addPrompt": {
    "defaultMessage": "Add new prompt"
  },
  "contentAi.stationConfig.promptsTitle": {
    "defaultMessage": "Prompts"
  },
  "contentAi.stationConfig.updated": {
    "defaultMessage": "Content AI config for {stationName} updated"
  },
  "contentAi.steps.adaptAndPublish": {
    "defaultMessage": "Adapt and publish to networks"
  },
  "contentAi.steps.aiArticles.choosePrompt": {
    "defaultMessage": "Choose Prompt"
  },
  "contentAi.steps.editContent": {
    "defaultMessage": "Edit content"
  },
  "contentAi.steps.generateArticles": {
    "defaultMessage": "Generate articles"
  },
  "contentAi.title": {
    "defaultMessage": "Content AI"
  },
  "contentAi.userArticle.generatedForWeb": {
    "defaultMessage": "Content generated for Web"
  },
  "contentAi.userArticle.primaryArticle": {
    "defaultMessage": "Primary article"
  },
  "contentAi.userArticle.useFooter": {
    "defaultMessage": "Use footer:"
  },
  "contentAi.useThisArticle": {
    "defaultMessage": "Use this article"
  },
  "contentAi.viewFullArticle": {
    "defaultMessage": "View full article"
  },
  "contentAi.wizard.adaptContentTitle": {
    "defaultMessage": "Adapt the content and publish it on social."
  },
  "contentAi.wizard.almostThereTitle": {
    "defaultMessage": "Almost there! Just {count} more steps."
  },
  "contentAi.wizard.createFragmentStep": {
    "defaultMessage": "Create fragment"
  },
  "contentAi.wizard.editArticleTitle": {
    "defaultMessage": "Edit your article to publish it."
  },
  "core.screen.hotkeys.modalTitle": {
    "defaultMessage": "Hotkeys"
  },
  "core.screen.hotkeys.showBtnText": {
    "defaultMessage": "Hotkeys"
  },
  "core.sidenav.adminIndicatorText": {
    "defaultMessage": "Admin"
  },
  "core.sidenav.collapseTooltip": {
    "defaultMessage": "Close menu"
  },
  "core.sidenav.darkModeTooltip": {
    "defaultMessage": "Dark"
  },
  "core.sidenav.defaultModeLabel": {
    "defaultMessage": "Default"
  },
  "core.sidenav.expandTooltip": {
    "defaultMessage": "Open menu"
  },
  "core.sidenav.lightModeTooltip": {
    "defaultMessage": "Light"
  },
  "core.sidenav.logoutBtnText": {
    "defaultMessage": "Logout"
  },
  "core.sidenav.notificationsEmpty": {
    "defaultMessage": "No notifications"
  },
  "core.sidenav.settingsBtnText": {
    "defaultMessage": "User settings"
  },
  "core.sidenav.themeToggle.tour.description": {
    "defaultMessage": "Open the account menu to choose Default, Dark, or Light."
  },
  "core.sidenav.themeToggle.tour.title": {
    "defaultMessage": "Theme options available"
  },
  "date.justNow": {
    "defaultMessage": "Just now"
  },
  "fleet.devices.card.lastSeen": {
    "defaultMessage": "Last seen {relativeTime}"
  },
  "fleet.devices.card.mapAlt": {
    "defaultMessage": "Map of {name}"
  },
  "fleet.devices.card.noLastSeen": {
    "defaultMessage": "Never seen online"
  },
  "fleet.devices.card.openAdminPanel": {
    "defaultMessage": "Open admin panel"
  },
  "fleet.devices.card.viewOnMap": {
    "defaultMessage": "View on map"
  },
  "fleet.devices.filters.id": {
    "defaultMessage": "ID"
  },
  "fleet.devices.filters.idPlaceholder": {
    "defaultMessage": "Search by ID"
  },
  "fleet.devices.filters.name": {
    "defaultMessage": "Name"
  },
  "fleet.devices.filters.namePlaceholder": {
    "defaultMessage": "Search by name"
  },
  "fleet.devices.filters.status": {
    "defaultMessage": "Status"
  },
  "fleet.devices.listScreen.title": {
    "defaultMessage": "Devices"
  },
  "fleet.devices.status.offline": {
    "defaultMessage": "Offline"
  },
  "fleet.devices.status.online": {
    "defaultMessage": "Online"
  },
  "fleet.devices.type.airnode": {
    "defaultMessage": "AirNode"
  },
  "fleet.devices.type.streamBox": {
    "defaultMessage": "StreamBox"
  },
  "fleet.nav.title": {
    "defaultMessage": "Devices"
  },
  "form.array.addButtonLabel": {
    "defaultMessage": "Add"
  },
  "form.array.emptyMessage": {
    "defaultMessage": "No items defined yet"
  },
  "form.array.fieldError": {
    "defaultMessage": "Field error"
  },
  "form.frameThumbnailLabel": {
    "defaultMessage": "Frame to use as thumbnail"
  },
  "fragmentMedia.audio.chunkPill.unlabeledChunk": {
    "defaultMessage": "Segment {n}"
  },
  "fragments.addScreen.createAndGoShort": {
    "defaultMessage": "Create and go"
  },
  "fragments.addScreen.createAndOpen": {
    "defaultMessage": "Create and go to fragment"
  },
  "fragments.addScreen.created": {
    "defaultMessage": "Fragment created"
  },
  "fragments.addScreen.createError": {
    "defaultMessage": "Could not create fragment"
  },
  "fragments.addScreen.createOnly": {
    "defaultMessage": "Create"
  },
  "fragments.addScreen.exportError": {
    "defaultMessage": "Could not start external export"
  },
  "fragments.addScreen.exportMissingConnection": {
    "defaultMessage": "Could not start export: publication account is missing"
  },
  "fragments.addScreen.externalExportError": {
    "defaultMessage": "Could not start external export"
  },
  "fragments.addScreen.goTo": {
    "defaultMessage": "Go to fragment"
  },
  "fragments.addScreen.splitSubmit.tour.description": {
    "defaultMessage": "Use this menu to create the fragment and go to its detail in one step."
  },
  "fragments.addScreen.splitSubmit.tour.title": {
    "defaultMessage": "Create and go to fragment"
  },
  "fragments.card.posterProcessing": {
    "defaultMessage": "Processing"
  },
  "fragments.cloneScreen.cloned": {
    "defaultMessage": "Fragment cloned"
  },
  "fragments.cloneScreen.cloneError": {
    "defaultMessage": "Could not clone fragment"
  },
  "fragments.cloneScreen.defaultTitle": {
    "defaultMessage": "{title} (copy)"
  },
  "fragments.cloneScreen.inputLabel": {
    "defaultMessage": "New title"
  },
  "fragments.cloneScreen.inputRequired": {
    "defaultMessage": "Title is required"
  },
  "fragments.cloneScreen.title": {
    "defaultMessage": "Clone fragment"
  },
  "fragments.contentAi.generateFromFragment": {
    "defaultMessage": "Generate content from this fragment"
  },
  "fragments.contentAi.noPermission": {
    "defaultMessage": "You do not have permission to create content"
  },
  "fragments.deleteScreen.deleted": {
    "defaultMessage": "Fragment deleted"
  },
  "fragments.deleteScreen.deleteError": {
    "defaultMessage": "Could not delete fragment"
  },
  "fragments.deleteScreen.prompt": {
    "defaultMessage": "Do you want to delete the fragment <b>{title}</b>? {br} This action cannot be undone."
  },
  "fragments.deleteScreen.title": {
    "defaultMessage": "Delete fragment"
  },
  "fragments.delivery.destinationStation": {
    "defaultMessage": "Destination station"
  },
  "fragments.delivery.exportStarted": {
    "defaultMessage": "Export started"
  },
  "fragments.delivery.exportStartError": {
    "defaultMessage": "An error occurred while starting the export, please contact support (status: {status})"
  },
  "fragments.delivery.savedAt": {
    "defaultMessage": "Saved at {uri}"
  },
  "fragments.deliveryStatus.destinationStationLabel": {
    "defaultMessage": "Destination station"
  },
  "fragments.deliveryStatus.enable": {
    "defaultMessage": "Enable external export"
  },
  "fragments.deliveryStatus.none": {
    "defaultMessage": "Fragment not exported"
  },
  "fragments.deliveryStatus.start": {
    "defaultMessage": "Start external export"
  },
  "fragments.export.audioMp3GeneratingTooltip": {
    "defaultMessage": "MP3 generation in progress"
  },
  "fragments.export.downloadAudioMp3": {
    "defaultMessage": "Download audio (MP3)"
  },
  "fragments.export.downloadMedia": {
    "defaultMessage": "Download {type}"
  },
  "fragments.export.downloadMediaAudioAac": {
    "defaultMessage": "Download {type} (aac)"
  },
  "fragments.export.publishError": {
    "defaultMessage": "An error occurred while publishing"
  },
  "fragments.export.publishingInProgress": {
    "defaultMessage": "Publication in progress..."
  },
  "fragments.exportStatus.externalExportNotEnabled": {
    "defaultMessage": "External export is not enabled, please contact support."
  },
  "fragments.exportStatus.ready": {
    "defaultMessage": "Ready"
  },
  "fragments.exportView.tabExternalExport": {
    "defaultMessage": "Export"
  },
  "fragments.exportView.tabFiles": {
    "defaultMessage": "Files"
  },
  "fragments.exportView.tabPublish": {
    "defaultMessage": "Networks"
  },
  "fragments.filter.hasContentAi": {
    "defaultMessage": "Contenido AI"
  },
  "fragments.filter.hasExternalDelivery": {
    "defaultMessage": "External export"
  },
  "fragments.filter.onlyMine": {
    "defaultMessage": "Only mine"
  },
  "fragments.filter.publishedPlatforms": {
    "defaultMessage": "Plataformas publicadas"
  },
  "fragments.form.addEmoji": {
    "defaultMessage": "Add emoji"
  },
  "fragments.form.description.placeholder": {
    "defaultMessage": "E.g.: Recorded at the Luzhniki stadium in Moscow during the World Cup"
  },
  "fragments.form.emojiPickerOk": {
    "defaultMessage": "OK"
  },
  "fragments.form.emojiSearchPlaceholder": {
    "defaultMessage": "Search"
  },
  "fragments.form.footer.placeholder": {
    "defaultMessage": "Add footer"
  },
  "fragments.form.header": {
    "defaultMessage": "Create fragment"
  },
  "fragments.form.header.noRangeSelected": {
    "defaultMessage": "No range selected"
  },
  "fragments.form.publishOn": {
    "defaultMessage": "Quick publish"
  },
  "fragments.form.tags.placeholder": {
    "defaultMessage": "E.g.: interview, messi, world cup, moscow"
  },
  "fragments.form.title.placeholder": {
    "defaultMessage": "E.g.: Interview with Messi"
  },
  "fragments.listScreen.allFragments": {
    "defaultMessage": "Fragments"
  },
  "fragments.listScreen.failed": {
    "defaultMessage": "Failed to send to"
  },
  "fragments.listScreen.scheduled": {
    "defaultMessage": "Scheduled"
  },
  "fragments.listScreen.sentTo": {
    "defaultMessage": "Sent to"
  },
  "fragments.listScreen.unpublished": {
    "defaultMessage": "Unpublished"
  },
  "fragments.listV3.section.previous": {
    "defaultMessage": "Previous"
  },
  "fragments.listV3.section.today": {
    "defaultMessage": "Today"
  },
  "fragments.listV3.section.yesterday": {
    "defaultMessage": "Yesterday"
  },
  "fragments.listV3.tour.addFilter.description": {
    "defaultMessage": "Add filters like Content AI, External export and Published platforms from this button to refine the fragments list."
  },
  "fragments.listV3.tour.addFilter.title": {
    "defaultMessage": "New filters available"
  },
  "fragments.listV3.tour.viewToggle.description": {
    "defaultMessage": "Switch between list and grid (wide, normal or compact) to view fragments your way."
  },
  "fragments.listV3.tour.viewToggle.title": {
    "defaultMessage": "Fragment view"
  },
  "fragments.mediaStatus.regenerate": {
    "defaultMessage": "No progress? Regenerate media"
  },
  "fragments.mediaStatus.regenerateError": {
    "defaultMessage": "Could not regenerate media"
  },
  "fragments.mediaStatus.regenerateStarted": {
    "defaultMessage": "Fragment media regeneration started"
  },
  "fragments.mediaStatus.title": {
    "defaultMessage": "Media file"
  },
  "fragments.mediaStatus.waiting": {
    "defaultMessage": "Media generation in progress"
  },
  "fragments.props.createdBy": {
    "defaultMessage": "Created by"
  },
  "fragments.props.description": {
    "defaultMessage": "Description"
  },
  "fragments.props.tag": {
    "defaultMessage": "Tag"
  },
  "fragments.props.tags": {
    "defaultMessage": "Tags"
  },
  "fragments.props.title": {
    "defaultMessage": "Title"
  },
  "fragments.subtitlesStatus.add": {
    "defaultMessage": "Add speaker ID"
  },
  "fragments.subtitlesStatus.download": {
    "defaultMessage": "Download subtitles"
  },
  "fragments.subtitlesStatus.formatJson": {
    "defaultMessage": ".JSON"
  },
  "fragments.subtitlesStatus.formatSrt": {
    "defaultMessage": ".SRT"
  },
  "fragments.subtitlesStatus.formatTxt": {
    "defaultMessage": ".TXT"
  },
  "fragments.subtitlesStatus.title": {
    "defaultMessage": "Subtitles"
  },
  "fragments.title": {
    "defaultMessage": "Fragments"
  },
  "fragments.transcription.panelTitle": {
    "defaultMessage": "Transcription"
  },
  "fragments.transcription.v2.editModeTooltipOff": {
    "defaultMessage": "Edit mode: off"
  },
  "fragments.transcription.v2.editModeTooltipOn": {
    "defaultMessage": "Edit mode: on"
  },
  "fragments.transcription.v2.editSaveError": {
    "defaultMessage": "Could not save the word. Please try again."
  },
  "fragments.transcription.v2.efficiencyTooltipOff": {
    "defaultMessage": "Per-word efficiency: off"
  },
  "fragments.transcription.v2.efficiencyTooltipOn": {
    "defaultMessage": "Per-word efficiency: on"
  },
  "fragments.transcription.v2.searchNoMatches": {
    "defaultMessage": "No matches"
  },
  "fragments.transcription.v2.searchTooltipOff": {
    "defaultMessage": "Search: off"
  },
  "fragments.transcription.v2.searchTooltipOn": {
    "defaultMessage": "Search: on"
  },
  "fragments.transcription.v2.syncTooltipOff": {
    "defaultMessage": "Sync transcription with playback: off"
  },
  "fragments.transcription.v2.syncTooltipOn": {
    "defaultMessage": "Sync transcription with playback: on"
  },
  "fragments.video.subtitlesTrackLabel": {
    "defaultMessage": "Subtitles"
  },
  "fragments.view.descriptionTitle": {
    "defaultMessage": "Description"
  },
  "fragments.view.metadata.openInLogger": {
    "defaultMessage": "Open in Logger:"
  },
  "fragments.view.metadata.goToStream": {
    "defaultMessage": "Start"
  },
  "fragments.view.metadata.goToStreamFromPlayback": {
    "defaultMessage": "Current time"
  },
  "fragments.view.metadata.goToStreamWithSelection": {
    "defaultMessage": "Selection"
  },
  "fragments.view.regenerateMedia": {
    "defaultMessage": "Regenerate media"
  },
  "fragments.viewScreen.mediaNotReadyTooltip": {
    "defaultMessage": "Waiting for fragment media"
  },
  "fragments.viewScreen.title": {
    "defaultMessage": "Info"
  },
  "fragments.viewScreen.transcriptionNotReadyTooltip": {
    "defaultMessage": "Waiting for fragment transcription"
  },
  "globalLivePlayer.title": {
    "defaultMessage": "Live player"
  },
  "impersonation.currentUserTitle": {
    "defaultMessage": "Saved user"
  },
  "impersonation.tabDeepLinkUserTitle": {
    "defaultMessage": "This tab user (deep link)"
  },
  "impersonation.clearTabAuthAsAriaLabel": {
    "defaultMessage": "Clear tab user"
  },
  "impersonation.tabAuthAsBadgeLabel": {
    "defaultMessage": "Tab"
  },
  "impersonation.tabAuthAsBadgeTooltip": {
    "defaultMessage": "Impersonation only in this tab"
  },
  "impersonation.deleteAriaLabel": {
    "defaultMessage": "Delete"
  },
  "impersonation.enterToSelect": {
    "defaultMessage": "Enter to select"
  },
  "impersonation.clientAdminChip": {
    "defaultMessage": "Client Admin"
  },
  "impersonation.groups.clientAdmins": {
    "defaultMessage": "Client admins"
  },
  "impersonation.groups.clientUsers": {
    "defaultMessage": "Client users"
  },
  "impersonation.groups.mediainboxUsers": {
    "defaultMessage": "Mediainbox users"
  },
  "impersonation.impersonateAriaLabel": {
    "defaultMessage": "Impersonate"
  },
  "impersonation.pageTitle": {
    "defaultMessage": "Impersonate user"
  },
  "impersonation.recentUsersTitle": {
    "defaultMessage": "Recently impersonated users"
  },
  "impersonation.searchHelper": {
    "defaultMessage": "Select a user to start impersonating them."
  },
  "impersonation.searchLabel": {
    "defaultMessage": "Search user to impersonate"
  },
  "itemsViewLayout.gridCompact": {
    "defaultMessage": "Compact grid"
  },
  "itemsViewLayout.gridNormal": {
    "defaultMessage": "Normal grid"
  },
  "itemsViewLayout.gridWide": {
    "defaultMessage": "Wide grid"
  },
  "itemsViewLayout.list": {
    "defaultMessage": "List"
  },
  "jointFragments.chunkLabel.edit": {
    "defaultMessage": "Edit label"
  },
  "jointFragments.chunkLabel.field": {
    "defaultMessage": "New label"
  },
  "jointFragments.chunkLabel.modalTitle": {
    "defaultMessage": "Set segment label"
  },
  "jointFragments.editorScreen.chunkActions.delete": {
    "defaultMessage": "Delete this segment"
  },
  "jointFragments.editorScreen.chunkActions.moveAfter": {
    "defaultMessage": "Move after"
  },
  "jointFragments.editorScreen.chunkActions.moveBefore": {
    "defaultMessage": "Move before"
  },
  "jointFragments.editorScreen.noChunks": {
    "defaultMessage": "No segments added yet to the fragment"
  },
  "jointFragments.editorScreen.title": {
    "defaultMessage": "Editor"
  },
  "jointFragments.editorScreen.toolbar.create": {
    "defaultMessage": "Create fragment"
  },
  "jointFragments.form.externalExport.allowedLabel": {
    "defaultMessage": "External export"
  },
  "jointFragments.overview.closeEditor": {
    "defaultMessage": "Close editor"
  },
  "jointFragments.overview.createNew": {
    "defaultMessage": "Create new fragment"
  },
  "jointFragments.overview.detailLink": {
    "defaultMessage": "View fragment detail"
  },
  "jointFragments.overview.message": {
    "defaultMessage": "Fragment was saved"
  },
  "jointFragments.props.chunk": {
    "defaultMessage": "Chunk"
  },
  "livePlayer.toggle.mode.fullscreen": {
    "defaultMessage": "Open in fullscreen"
  },
  "livePlayer.toggle.mode.inline": {
    "defaultMessage": "Open in thumbnail"
  },
  "livePlayer.toggle.tooltip": {
    "defaultMessage": "Open LIVE"
  },
  "logger.auditControls.audioMatches": {
    "defaultMessage": "Media matches"
  },
  "logger.auditControls.mentionMatches": {
    "defaultMessage": "Mention matches"
  },
  "logger.diarization.confidence": {
    "defaultMessage": "Confidence"
  },
  "logger.downloadingSegments": {
    "defaultMessage": "Downloading segments {progress}%"
  },
  "logger.liveMentions.showMention": {
    "defaultMessage": "Show mention"
  },
  "logger.navLabel": {
    "defaultMessage": "Logger"
  },
  "logger.persons.empty": {
    "defaultMessage": "No people detected in this range"
  },
  "logger.persons.filter.all": {
    "defaultMessage": "All"
  },
  "logger.persons.filter.face": {
    "defaultMessage": "With face"
  },
  "logger.persons.filter.unknown": {
    "defaultMessage": "Unidentified"
  },
  "logger.persons.filter.voice": {
    "defaultMessage": "With voice"
  },
  "logger.persons.source.face": {
    "defaultMessage": "Face"
  },
  "logger.persons.source.voice": {
    "defaultMessage": "Voice"
  },
  "logger.persons.table.appearances": {
    "defaultMessage": "Appearances"
  },
  "logger.persons.table.appearancesDetail": {
    "defaultMessage": "Appearance details"
  },
  "logger.persons.table.confidence": {
    "defaultMessage": "Confidence"
  },
  "logger.persons.table.onScreen": {
    "defaultMessage": "On screen"
  },
  "logger.persons.table.sources": {
    "defaultMessage": "Sources"
  },
  "logger.persons.table.speaking": {
    "defaultMessage": "Speaking"
  },
  "logger.persons.table.timeline": {
    "defaultMessage": "Appearances in focus"
  },
  "logger.persons.track.collapse": {
    "defaultMessage": "Collapse"
  },
  "logger.persons.track.lanes": {
    "defaultMessage": "View by person"
  },
  "logger.persons.track.title": {
    "defaultMessage": "People"
  },
  "logger.persons.unknown": {
    "defaultMessage": "Unidentified person"
  },
  "logger.reports.loggerReportsTitle": {
    "defaultMessage": "Logger reports"
  },
  "logger.reports.streamQuality.availability.rangeBrush.label": {
    "defaultMessage": "Adjust range"
  },
  "logger.reports.streamQuality.availability.rangeBrush.resetFullRange": {
    "defaultMessage": "Show full report range"
  },
  "logger.reports.streamQuality.availability.table.action.openLogger": {
    "defaultMessage": "Open the logger at this time"
  },
  "logger.reports.streamQuality.availability.table.col.duration": {
    "defaultMessage": "Duration"
  },
  "logger.reports.streamQuality.availability.table.col.end": {
    "defaultMessage": "End"
  },
  "logger.reports.streamQuality.availability.table.col.issueType": {
    "defaultMessage": "Type"
  },
  "logger.reports.streamQuality.availability.table.col.start": {
    "defaultMessage": "Start"
  },
  "logger.reports.streamQuality.availability.table.col.station": {
    "defaultMessage": "Station"
  },
  "logger.reports.streamQuality.availability.tooltip.clickOpenLogger": {
    "defaultMessage": "Click to open in Logger"
  },
  "logger.reports.streamQuality.availability.tooltip.duration": {
    "defaultMessage": "Duration: {duration}"
  },
  "logger.reports.streamQuality.availability.tooltip.gap": {
    "defaultMessage": "No broadcast"
  },
  "logger.reports.streamQuality.availability.tooltip.issueKind.poorQuality": {
    "defaultMessage": "Poor quality"
  },
  "logger.reports.streamQuality.availability.tooltip.issueKind.silent": {
    "defaultMessage": "Silence"
  },
  "logger.reports.streamQuality.availability.tooltip.range": {
    "defaultMessage": "{from} – {to}"
  },
  "logger.reports.streamQuality.emptyState.help": {
    "defaultMessage": "Choose a date range and stations to generate the report."
  },
  "logger.reports.streamQuality.form.dateRangeLabel": {
    "defaultMessage": "Date range"
  },
  "logger.reports.streamQuality.form.stationsLabel": {
    "defaultMessage": "Stations"
  },
  "logger.reports.streamQuality.form.stationsPlaceholder": {
    "defaultMessage": "All stations"
  },
  "logger.reports.streamQuality.kpis.continuityIncidentDurationAvg": {
    "defaultMessage": "Average continuity incident duration"
  },
  "logger.reports.streamQuality.kpis.continuityIncidentsTotal": {
    "defaultMessage": "Continuity incidents"
  },
  "logger.reports.streamQuality.kpis.healthScore": {
    "defaultMessage": "Health score"
  },
  "logger.reports.streamQuality.kpis.qualityAvgNotApplicable": {
    "defaultMessage": "—"
  },
  "logger.reports.streamQuality.kpis.qualityIncidentDurationAvg": {
    "defaultMessage": "Average quality incident duration"
  },
  "logger.reports.streamQuality.kpis.qualityIncidentsTotal": {
    "defaultMessage": "Quality incidents"
  },
  "logger.reports.streamQuality.kpis.stationsWithContinuityIncidents": {
    "defaultMessage": "Stations with continuity incidents"
  },
  "logger.reports.streamQuality.kpis.stationsWithIncidents": {
    "defaultMessage": "Stations with incidents"
  },
  "logger.reports.streamQuality.kpis.stationsWithQualityIncidents": {
    "defaultMessage": "Stations with quality incidents"
  },
  "logger.reports.streamQuality.stationStatusFilter.disabledAnalysisIntervalsLegend": {
    "defaultMessage": "= Interval without quality check"
  },
  "logger.reports.streamQuality.stationStatusFilter.discontinuity": {
    "defaultMessage": "Discontinuity"
  },
  "logger.reports.streamQuality.stationStatusFilter.filterByIncidentsLabel": {
    "defaultMessage": "Filter by incidents: "
  },
  "logger.reports.streamQuality.stationStatusFilter.noIncidents": {
    "defaultMessage": "No incidents"
  },
  "logger.reports.streamQuality.stationStatusFilter.noMatchingStations": {
    "defaultMessage": "No stations match the selected filters. Try a different combination."
  },
  "logger.reports.streamQuality.stationStatusFilter.poorQuality": {
    "defaultMessage": "Poor quality"
  },
  "logger.reports.streamQuality.stationStatusFilter.silent": {
    "defaultMessage": "Silent"
  },
  "logger.reports.streamQuality.tabLabel": {
    "defaultMessage": "Stream Quality"
  },
  "logger.sidenav.panorama": {
    "defaultMessage": "Panorama"
  },
  "logger.sidenav.reportes": {
    "defaultMessage": "Reports"
  },
  "logger.sidenav.youtube": {
    "defaultMessage": "YouTube"
  },
  "logger.status.filter.offline": {
    "defaultMessage": "Offline"
  },
  "logger.status.filter.online": {
    "defaultMessage": "Online"
  },
  "logger.statusScreen.cleanFilters": {
    "defaultMessage": "Clean filters"
  },
  "logger.statusScreen.count": {
    "defaultMessage": "{count, plural, =0 {No stations found} one {1 station found} other {# stations found} }"
  },
  "logger.statusScreen.enterFullscreen": {
    "defaultMessage": "Fullscreen"
  },
  "logger.statusScreen.exitFullscreen": {
    "defaultMessage": "Exit fullscreen"
  },
  "logger.statusScreen.favoritesSection": {
    "defaultMessage": "Favorites ({count})"
  },
  "logger.statusScreen.groupSection": {
    "defaultMessage": "{name} ({count})"
  },
  "logger.statusScreen.loading": {
    "defaultMessage": "Loading logger status"
  },
  "logger.statusScreen.myStationsSection": {
    "defaultMessage": "My stations ({count})"
  },
  "logger.statusScreen.noActivity": {
    "defaultMessage": "No recent activity registered"
  },
  "logger.statusScreen.sharedStationsSection": {
    "defaultMessage": "External stations ({count})"
  },
  "logger.statusScreen.stationAccess": {
    "defaultMessage": "Station access"
  },
  "logger.statusScreen.stationAccessOwned": {
    "defaultMessage": "My stations"
  },
  "logger.statusScreen.stationAccessShared": {
    "defaultMessage": "External stations"
  },
  "logger.statusScreen.stationType": {
    "defaultMessage": "Station type"
  },
  "logger.statusScreen.stationTypeRadio": {
    "defaultMessage": "Radio"
  },
  "logger.statusScreen.stationTypeTv": {
    "defaultMessage": "TV"
  },
  "logger.statusScreen.stationTypeYoutube": {
    "defaultMessage": "YouTube"
  },
  "logger.statusScreen.statusActivity": {
    "defaultMessage": "Status"
  },
  "logger.statusScreen.title": {
    "defaultMessage": "Panorama"
  },
  "logger.statusScreen.tour.viewToggle.description": {
    "defaultMessage": "Switch between list and grid (wide, normal or compact) to view stations your way."
  },
  "logger.statusScreen.tour.viewToggle.title": {
    "defaultMessage": "Station view"
  },
  "logger.statusScreen.youtubeNative.last24h": {
    "defaultMessage": "Last 24 hours"
  },
  "logger.statusScreen.youtubeNative.noEmissionInProgress": {
    "defaultMessage": "No broadcast in progress"
  },
  "logger.statusScreen.youtubeNative.noRecentBroadcastsHelp": {
    "defaultMessage": "No broadcasts were recorded in the last 24 hours."
  },
  "logger.statusScreen.youtubeNative.offline": {
    "defaultMessage": "OFFLINE"
  },
  "logger.statusScreen.youtubeNative.peakViewersTooltip": {
    "defaultMessage": "{count} peak viewers"
  },
  "logger.statusScreen.youtubeNative.recentTransmissions": {
    "defaultMessage": "Recent Transmissions"
  },
  "logger.statusScreen.youtubeNative.today": {
    "defaultMessage": "Today"
  },
  "logger.statusScreen.youtubeNative.yesterday": {
    "defaultMessage": "Yesterday"
  },
  "logger.streamBox.goToDevice": {
    "defaultMessage": "Go to device"
  },
  "logger.streamScreen.audit.adOverlayLabel": {
    "defaultMessage": "Ad Overlay"
  },
  "logger.streamScreen.auditControls.adOverlay": {
    "defaultMessage": "Ad overlay"
  },
  "logger.streamScreen.auditControls.youTubeViewers": {
    "defaultMessage": "YouTube viewers"
  },
  "logger.streamScreen.autoOpenFragment.never": {
    "defaultMessage": "Never"
  },
  "logger.streamScreen.autoOpenFragment.onStartAndEnd": {
    "defaultMessage": "When marking start and end"
  },
  "logger.streamScreen.autoOpenFragment.onStartOrEnd": {
    "defaultMessage": "When marking start or end"
  },
  "logger.streamScreen.controls.liveIndicator": {
    "defaultMessage": "Live"
  },
  "logger.streamScreen.controls.loadLatestBtn": {
    "defaultMessage": "Load latest recording"
  },
  "logger.streamScreen.controls.partialSegmentCoverage.tooltip": {
    "defaultMessage": "No broadcast is available for the entire selected range. Only the part of the range where there was transmission is shown. (Available range: {fromTime} - {toTime})"
  },
  "logger.streamScreen.controls.playLive": {
    "defaultMessage": "Play live stream"
  },
  "logger.streamScreen.controls.stop": {
    "defaultMessage": "Stop"
  },
  "logger.streamScreen.controls.timeMove.back15m": {
    "defaultMessage": "-15m"
  },
  "logger.streamScreen.controls.timeMove.back1h": {
    "defaultMessage": "-1h"
  },
  "logger.streamScreen.controls.timeMove.forward15m": {
    "defaultMessage": "+15m"
  },
  "logger.streamScreen.controls.timeMove.forward1h": {
    "defaultMessage": "+1h"
  },
  "logger.streamScreen.controls.updated": {
    "defaultMessage": "Updated <time>{time}</time>"
  },
  "logger.streamScreen.controls.youtubeBroadcastsList": {
    "defaultMessage": "View all broadcasts"
  },
  "logger.streamScreen.controls.youtubeLiveViewers": {
    "defaultMessage": "{count} live viewers"
  },
  "logger.streamScreen.copyCursorAt": {
    "defaultMessage": "Copy link with timestamp {value}"
  },
  "logger.streamScreen.copyCursorLinkCopied": {
    "defaultMessage": "Link copied to clipboard"
  },
  "logger.streamScreen.cursorMenu.cancel": {
    "defaultMessage": "Cancel"
  },
  "logger.streamScreen.cursorMenu.endSelection": {
    "defaultMessage": "End selection here"
  },
  "logger.streamScreen.cursorMenu.startSelection": {
    "defaultMessage": "Start selection here"
  },
  "logger.streamScreen.downloadMedia.downloadError": {
    "defaultMessage": "Could not get the download link"
  },
  "logger.streamScreen.downloadMedia.enqueueError": {
    "defaultMessage": "Could not start the export. Please try again."
  },
  "logger.streamScreen.downloadMedia.error": {
    "defaultMessage": "Error loading export status"
  },
  "logger.streamScreen.downloadMedia.fileGeneratedSuccessfully": {
    "defaultMessage": "File generated successfully"
  },
  "logger.streamScreen.downloadMedia.preparing": {
    "defaultMessage": "Preparing file..."
  },
  "logger.streamScreen.focusTracks.hide": {
    "defaultMessage": "Hide track"
  },
  "logger.streamScreen.focusTracks.show": {
    "defaultMessage": "Show track"
  },
  "logger.streamScreen.hotkeys.ADD_CHUNK_FROM_FOCUS_SELECTION.label": {
    "defaultMessage": "Add selection to joint fragment"
  },
  "logger.streamScreen.hotkeys.category.cursor": {
    "defaultMessage": "Cursor"
  },
  "logger.streamScreen.hotkeys.category.focus": {
    "defaultMessage": "Focus"
  },
  "logger.streamScreen.hotkeys.category.playback": {
    "defaultMessage": "Playback"
  },
  "logger.streamScreen.hotkeys.category.selection": {
    "defaultMessage": "Selection"
  },
  "logger.streamScreen.hotkeys.CLEAR_SELECTION.label": {
    "defaultMessage": "Clear selection"
  },
  "logger.streamScreen.hotkeys.CREATE_FRAGMENT.label": {
    "defaultMessage": "Create fragment from selection"
  },
  "logger.streamScreen.hotkeys.CURSOR_BACK_1S.label": {
    "defaultMessage": "Move cursor back 1 second"
  },
  "logger.streamScreen.hotkeys.CURSOR_BACK_5S.label": {
    "defaultMessage": "Move cursor back 5 seconds"
  },
  "logger.streamScreen.hotkeys.CURSOR_FORWARD_1S.label": {
    "defaultMessage": "Move cursor forward 1 second"
  },
  "logger.streamScreen.hotkeys.CURSOR_FORWARD_5S.label": {
    "defaultMessage": "Move cursor forward 5 seconds"
  },
  "logger.streamScreen.hotkeys.DECREMENT_CURSOR_SELECTION.label": {
    "defaultMessage": "Decrement selection range 5 seconds"
  },
  "logger.streamScreen.hotkeys.DOWNLOAD_AUDIO_SELECTION_VIDEO_ONLY.label": {
    "defaultMessage": "Download selection audio (video stations only)"
  },
  "logger.streamScreen.hotkeys.DOWNLOAD_SELECTION.label": {
    "defaultMessage": "Download selection"
  },
  "logger.streamScreen.hotkeys.END_CURSOR_SELECTION.label": {
    "defaultMessage": "End selection from cursor"
  },
  "logger.streamScreen.hotkeys.END_PLAY_TS_SELECTION.label": {
    "defaultMessage": "End selection from current playtime"
  },
  "logger.streamScreen.hotkeys.FOCUS_BACK_5M.label": {
    "defaultMessage": "Move focus back 5 minutes"
  },
  "logger.streamScreen.hotkeys.FOCUS_FORWARD_5M.label": {
    "defaultMessage": "Move focus forward 5 minutes"
  },
  "logger.streamScreen.hotkeys.FOCUS_FULL_IN.label": {
    "defaultMessage": "Focus full zoom in to cursor or selection"
  },
  "logger.streamScreen.hotkeys.FOCUS_FULL_OUT.label": {
    "defaultMessage": "Focus full zoom out"
  },
  "logger.streamScreen.hotkeys.FOCUS_ZOOM_SELECTION_IN.label": {
    "defaultMessage": "Zoom in to selection start"
  },
  "logger.streamScreen.hotkeys.FOCUS_ZOOM_SELECTION_OUT.label": {
    "defaultMessage": "Zoom in to selection end"
  },
  "logger.streamScreen.hotkeys.INCREMENT_CURSOR_SELECTION.label": {
    "defaultMessage": "Increment selection range 5 seconds"
  },
  "logger.streamScreen.hotkeys.PLAY_PAUSE.label": {
    "defaultMessage": "Play/pause"
  },
  "logger.streamScreen.hotkeys.START_CURSOR_SELECTION.label": {
    "defaultMessage": "Start selection from cursor"
  },
  "logger.streamScreen.hotkeys.START_PLAY_TS_SELECTION.label": {
    "defaultMessage": "Start selection from current playtime"
  },
  "logger.streamScreen.hotkeys.STREAM_BACK_1H.label": {
    "defaultMessage": "Move focus back 1 hour"
  },
  "logger.streamScreen.hotkeys.STREAM_FORWARD_1H.label": {
    "defaultMessage": "Move focus forward 1 hour"
  },
  "logger.streamScreen.hotkeys.ZOOM_IN_FOCUS.label": {
    "defaultMessage": "Zoom in focus"
  },
  "logger.streamScreen.hotkeys.ZOOM_OUT_FOCUS.label": {
    "defaultMessage": "Zoom out focus"
  },
  "logger.streamScreen.liveTopic.comesFrom": {
    "defaultMessage": "Comes from: "
  },
  "logger.streamScreen.liveTopics.entities.orgs": {
    "defaultMessage": "Organizations"
  },
  "logger.streamScreen.liveTopics.entities.people": {
    "defaultMessage": "People"
  },
  "logger.streamScreen.liveTopics.entities.places": {
    "defaultMessage": "Places"
  },
  "logger.streamScreen.liveTopics.noTopicsForRange": {
    "defaultMessage": "No topics detected for this range"
  },
  "logger.streamScreen.liveTopics.panel.categoryFilterLabel": {
    "defaultMessage": "Category"
  },
  "logger.streamScreen.liveTopics.panel.categoryFilterPlaceholder": {
    "defaultMessage": "All categories"
  },
  "logger.streamScreen.liveTopics.panel.goTo": {
    "defaultMessage": "Go"
  },
  "logger.streamScreen.liveTopics.panel.itemDeveloping": {
    "defaultMessage": "Developing"
  },
  "logger.streamScreen.liveTopics.panel.itemNew": {
    "defaultMessage": "New"
  },
  "logger.streamScreen.liveTopics.panel.keyPoints": {
    "defaultMessage": "Key points"
  },
  "logger.streamScreen.liveTopics.panel.loadMoreOtherDay": {
    "defaultMessage": "Show earlier than {date} {time}"
  },
  "logger.streamScreen.liveTopics.panel.loadMoreToday": {
    "defaultMessage": "Show earlier than {time}"
  },
  "logger.streamScreen.liveTopics.panel.newTopics": {
    "defaultMessage": "{count, plural, one {# new topic} other {# new topics}}"
  },
  "logger.streamScreen.liveTopics.panel.openPanel": {
    "defaultMessage": "Live Topics"
  },
  "logger.streamScreen.liveTopics.panel.textFilterClearButton": {
    "defaultMessage": "Clear search"
  },
  "logger.streamScreen.liveTopics.panel.textFilterLabel": {
    "defaultMessage": "Text"
  },
  "logger.streamScreen.liveTopics.panel.title": {
    "defaultMessage": "Live Topics"
  },
  "logger.streamScreen.liveTopics.popup.openInPanel": {
    "defaultMessage": "View more details"
  },
  "logger.streamScreen.liveTopics.track.title": {
    "defaultMessage": "Live Topics"
  },
  "logger.streamScreen.modes.defaultMode": {
    "defaultMessage": "Default mode"
  },
  "logger.streamScreen.modes.editorMode": {
    "defaultMessage": "Editor mode"
  },
  "logger.streamScreen.screenSettings.autoOpenFragment": {
    "defaultMessage": "Open fragment creation when selecting (default mode)"
  },
  "logger.streamScreen.screenSettings.btn": {
    "defaultMessage": "Settings"
  },
  "logger.streamScreen.screenSettings.keepSelectionOnRangeChange": {
    "defaultMessage": "Keep selection when changing range"
  },
  "logger.streamScreen.screenSettings.playOnCursorSet": {
    "defaultMessage": "Play when marking"
  },
  "logger.streamScreen.screenSettings.screenMode": {
    "defaultMessage": "Screen mode"
  },
  "logger.streamScreen.screenSettings.tooltip": {
    "defaultMessage": "Screen settings"
  },
  "logger.streamScreen.selection.clear": {
    "defaultMessage": "Clear selection"
  },
  "logger.streamScreen.selectionMenu.copyQuickShare": {
    "defaultMessage": "Copy quick share"
  },
  "logger.streamScreen.selectionMenu.copyQuickShareDone": {
    "defaultMessage": "Link copied"
  },
  "logger.streamScreen.selectionMenu.createFragment": {
    "defaultMessage": "Create fragment"
  },
  "logger.streamScreen.selectionMenu.unselect": {
    "defaultMessage": "Unselect"
  },
  "logger.youtubeBroadcasts.noYoutubeNativeStations": {
    "defaultMessage": "No hay emisoras con integración YouTube Native"
  },
  "logger.youtubeBroadcasts.pageTitle": {
    "defaultMessage": "Transmisiones de YouTube"
  },
  "logger.youtubePanorama.noRecentBroadcasts": {
    "defaultMessage": "No recent broadcasts"
  },
  "logger.youtubePanorama.recentTransmissionsTitle": {
    "defaultMessage": "Latest broadcasts"
  },
  "logger.youtubePanorama.recentTransmissionTitle": {
    "defaultMessage": "Latest broadcast"
  },
  "logger.youtubePanorama.viewAll": {
    "defaultMessage": "View all broadcasts"
  },
  "logger.youtubeStats.legend.channels": {
    "defaultMessage": "Channels"
  },
  "logger.youtubeStats.legend.otherChannels": {
    "defaultMessage": "Other channels"
  },
  "logger.youtubeStats.legend.ownChannel": {
    "defaultMessage": "Own channel"
  },
  "logger.youtubeStats.legend.selectAll": {
    "defaultMessage": "Select all"
  },
  "logger.youtubeStats.legend.selectNone": {
    "defaultMessage": "Select none"
  },
  "logger.youtubeStats.noDataForPeriod": {
    "defaultMessage": "No data available for this period"
  },
  "logger.youtubeStats.openYoutubeAtThisMoment": {
    "defaultMessage": "Click to go to YouTube at this moment"
  },
  "modulesAdminLocaleEs.m.admin.groups.addScreen.title": {
    "defaultMessage": "Create new group"
  },
  "modulesAdminLocaleEs.m.admin.groups.editScreen.title": {
    "defaultMessage": "Edit group"
  },
  "notifications.feed.archive": {
    "defaultMessage": "Archive"
  },
  "notifications.feed.filterAll": {
    "defaultMessage": "All"
  },
  "notifications.feed.filterRead": {
    "defaultMessage": "Read"
  },
  "notifications.feed.filterUnread": {
    "defaultMessage": "Unread"
  },
  "notifications.feed.loadMore": {
    "defaultMessage": "Load more"
  },
  "notifications.feed.markAllRead": {
    "defaultMessage": "Mark all as read"
  },
  "notifications.feed.title": {
    "defaultMessage": "Notifications"
  },
  "notifications.item.fallbackTitle": {
    "defaultMessage": "Notification"
  },
  "notifications.item.openVideo": {
    "defaultMessage": "View video"
  },
  "notifications.item.download": {
    "defaultMessage": "Download"
  },
  "notifications.preferences.category.audit": {
    "defaultMessage": "Audit"
  },
  "notifications.preferences.category.fragments": {
    "defaultMessage": "Fragments"
  },
  "notifications.preferences.category.socialUpload": {
    "defaultMessage": "Social"
  },
  "notifications.preferences.channel.email": {
    "defaultMessage": "Email"
  },
  "notifications.preferences.channel.inApp": {
    "defaultMessage": "In app"
  },
  "notifications.preferences.saveError": {
    "defaultMessage": "Could not save preferences"
  },
  "notifications.preferences.title": {
    "defaultMessage": "Notification preferences"
  },
  "notifications.preferences.unavailable": {
    "defaultMessage": "Notification preferences are not available."
  },
  "notifications.preferences.workflow.aodDeficiencyBreached.description": {
    "defaultMessage": "When an AOD run does not meet the minimum efficiency threshold"
  },
  "notifications.preferences.workflow.aodDeficiencyBreached.title": {
    "defaultMessage": "Insufficient AOD efficiency"
  },
  "notifications.preferences.workflow.evidenceExportCompleted.description": {
    "defaultMessage": "When a report evidence package is ready"
  },
  "notifications.preferences.workflow.evidenceExportCompleted.title": {
    "defaultMessage": "Evidence ready to download"
  },
  "notifications.preferences.workflow.socialUploadCompleted.description": {
    "defaultMessage": "When a video is published successfully to a social network"
  },
  "notifications.preferences.workflow.socialUploadCompleted.title": {
    "defaultMessage": "Successful publish"
  },
  "notifications.preferences.workflow.socialUploadFailed.description": {
    "defaultMessage": "When publishing a video to a social network fails"
  },
  "notifications.preferences.workflow.socialUploadFailed.title": {
    "defaultMessage": "Publish error"
  },
  "notifications.toast.close": {
    "defaultMessage": "Close"
  },
  "notifications.toast.story.showAgain": {
    "defaultMessage": "Show again"
  },
  "notifications.toast.viewLink": {
    "defaultMessage": "View"
  },
  "notifications.tour.bell.description": {
    "defaultMessage": "We centralize the status of your exports, reports, and system alerts. Click the bell to review your recent activity."
  },
  "notifications.tour.bell.title": {
    "defaultMessage": "Notifications center"
  },
  "notifications.tour.demo.aod.body": {
    "defaultMessage": "A deficiency was detected in the scheduled campaign."
  },
  "notifications.tour.demo.aod.title": {
    "defaultMessage": "AOD deficiency: Summer campaign"
  },
  "notifications.tour.demo.export.title": {
    "defaultMessage": "Evidence export ready"
  },
  "notifications.tour.demo.time.hourAgo": {
    "defaultMessage": "1 hour ago"
  },
  "notifications.tour.demo.time.recent": {
    "defaultMessage": "5 minutes ago"
  },
  "notifications.tour.demo.time.yesterday": {
    "defaultMessage": "yesterday"
  },
  "notifications.tour.demo.upload.title": {
    "defaultMessage": "YouTube upload completed"
  },
  "notifications.tour.feed.description": {
    "defaultMessage": "Filter, read, or archive your alerts from here. Use the gear icon (⚙️) to customize which notifications you want to receive."
  },
  "notifications.tour.feed.title": {
    "defaultMessage": "Manage your notifications"
  },
  "permissions.empty.description": {
    "defaultMessage": "No permissions are available."
  },
  "permissions.empty.title": {
    "defaultMessage": "No permissions found"
  },
  "permissions.error.description": {
    "defaultMessage": "There was an error loading the permissions. Please try again."
  },
  "permissions.error.title": {
    "defaultMessage": "Error loading permissions"
  },
  "playback.rangeWaveformPlayer.noSegments": {
    "defaultMessage": "No audio available for this range."
  },
  "search.contactAdmin": {
    "defaultMessage": "Contact your administrator"
  },
  "search.dateTime": {
    "defaultMessage": "Time"
  },
  "search.featureNotAvailable": {
    "defaultMessage": "This feature is not available for"
  },
  "search.helpFistLine": {
    "defaultMessage": "For advanced search operations:"
  },
  "search.helpPlusOp": {
    "defaultMessage": "The symbol + corresponds to the logical operator AND"
  },
  "search.helpVertialBarOp": {
    "defaultMessage": "The symbol | corresponds to the logical operator OR`"
  },
  "search.preview": {
    "defaultMessage": "Preview"
  },
  "search.title": {
    "defaultMessage": "Search"
  },
  "search.transcription": {
    "defaultMessage": "Transcription"
  },
  "segments.listScreen.futureRange": {
    "defaultMessage": "The selected range is in the future"
  },
  "segments.listScreen.futureRange.help": {
    "defaultMessage": "Select an earlier range to view the broadcast."
  },
  "segments.listScreen.noSegments": {
    "defaultMessage": "No broadcast"
  },
  "segments.listScreen.noSegments.help": {
    "defaultMessage": "Try changing the selected time range."
  },
  "segments.listScreen.tooRecentRange": {
    "defaultMessage": "The range is too recent"
  },
  "segments.listScreen.tooRecentRange.help": {
    "defaultMessage": "Select a range at least {minutes} minutes before the current time."
  },
  "settings.userSettings.form.name.label": {
    "defaultMessage": "Name"
  },
  "settings.userSettings.form.surname.label": {
    "defaultMessage": "Last name"
  },
  "settings.userSettings.title": {
    "defaultMessage": "User settings"
  },
  "socialExport.connect": {
    "defaultMessage": "Connect"
  },
  "socialExport.connectAlternatives.dialogTitle": {
    "defaultMessage": "Choose how to connect to {platform}"
  },
  "socialExport.connectAlternatives.permissionsLabel": {
    "defaultMessage": "Permissions"
  },
  "socialExport.connectAlternatives.recommendedBadge": {
    "defaultMessage": "Recommended"
  },
  "socialExport.connectAlternatives.redirecting": {
    "defaultMessage": "Redirecting to {platform} to connect..."
  },
  "socialExport.connections.accountIdentification": {
    "defaultMessage": "Account identification"
  },
  "socialExport.connections.connectedAccounts": {
    "defaultMessage": "Connected accounts"
  },
  "socialExport.connections.connectedByPrefix": {
    "defaultMessage": "Connected by"
  },
  "socialExport.connections.customName": {
    "defaultMessage": "Custom name"
  },
  "socialExport.connections.customNameHelper": {
    "defaultMessage": "Optional. Useful if there is more than one connection to the same profile."
  },
  "socialExport.connections.defaultConnectionName": {
    "defaultMessage": "Default"
  },
  "socialExport.connections.disconnectConfirmDescription": {
    "defaultMessage": "You are about to disconnect this integration. Are you sure?"
  },
  "socialExport.connections.disconnectWithStationsWarning": {
    "defaultMessage": "This account is linked to {count, plural, one {# station} other {# stations}}. Disconnecting will prevent those stations from publishing with it. Are you sure?"
  },
  "socialExport.connections.empty": {
    "defaultMessage": "No connected accounts"
  },
  "socialExport.connections.emptyHelp": {
    "defaultMessage": "Connect an account to start publishing to this platform."
  },
  "socialExport.connections.linkedStationsCount": {
    "defaultMessage": "{count, plural, =0 {No linked stations} one {# linked station} other {# linked stations}}"
  },
  "socialExport.connections.noLinkedStations": {
    "defaultMessage": "No linked stations yet"
  },
  "socialExport.connections.noneAssignedForStation": {
    "defaultMessage": "There are no connected accounts assigned to this station for this platform."
  },
  "socialExport.connections.connectionDetail": {
    "defaultMessage": "Details"
  },
  "socialExport.connections.selectConnection": {
    "defaultMessage": "Select an account to see details"
  },
  "socialExport.connections.selectForPublish": {
    "defaultMessage": "Publication account"
  },
  "socialExport.connections.selectStations": {
    "defaultMessage": "Stations"
  },
  "socialExport.connections.selectStationsHelper": {
    "defaultMessage": "Only these stations will be able to publish with this account."
  },
  "socialExport.connections.selectStationsPlaceholder": {
    "defaultMessage": "Select one or more stations"
  },
  "socialExport.connections.settingsTitle": {
    "defaultMessage": "Configure {name}"
  },
  "socialExport.connections.stationsPublishingWithAccount": {
    "defaultMessage": "Linked stations"
  },
  "socialExport.connectionSuccess.linkStations": {
    "defaultMessage": "Link stations to this account and configure the default values."
  },
  "socialExport.connectionSuccess.title": {
    "defaultMessage": "Connection successful with {name}"
  },
  "socialExport.dailymotion.apiKey": {
    "defaultMessage": "API key"
  },
  "socialExport.dailymotion.apiSecret": {
    "defaultMessage": "API secret"
  },
  "socialExport.dailymotion.channel.animals": {
    "defaultMessage": "Animals"
  },
  "socialExport.dailymotion.channel.auto": {
    "defaultMessage": "Cars"
  },
  "socialExport.dailymotion.channel.creation": {
    "defaultMessage": "Creation"
  },
  "socialExport.dailymotion.channel.fun": {
    "defaultMessage": "Fun"
  },
  "socialExport.dailymotion.channel.kids": {
    "defaultMessage": "Kids"
  },
  "socialExport.dailymotion.channel.lifestyle": {
    "defaultMessage": "Lifestyle"
  },
  "socialExport.dailymotion.channel.music": {
    "defaultMessage": "Music"
  },
  "socialExport.dailymotion.channel.news": {
    "defaultMessage": "News"
  },
  "socialExport.dailymotion.channel.people": {
    "defaultMessage": "People"
  },
  "socialExport.dailymotion.channel.school": {
    "defaultMessage": "School"
  },
  "socialExport.dailymotion.channel.shortfilms": {
    "defaultMessage": "Short films"
  },
  "socialExport.dailymotion.channel.sport": {
    "defaultMessage": "Sport"
  },
  "socialExport.dailymotion.channel.tech": {
    "defaultMessage": "Technology"
  },
  "socialExport.dailymotion.channel.travel": {
    "defaultMessage": "Travel"
  },
  "socialExport.dailymotion.channel.tv": {
    "defaultMessage": "TV"
  },
  "socialExport.dailymotion.channel.videogames": {
    "defaultMessage": "Video games"
  },
  "socialExport.dailymotion.channel.webcam": {
    "defaultMessage": "Webcam"
  },
  "socialExport.dailymotion.channelId": {
    "defaultMessage": "Channel ID"
  },
  "socialExport.dailymotion.channelIdHelper": {
    "defaultMessage": "7-character identifier"
  },
  "socialExport.dailymotion.connect.apiKeyDescription": {
    "defaultMessage": "Enter key, secret and channel ID from Dailymotion Studio. Ideal for organizations."
  },
  "socialExport.dailymotion.connect.apiKeyName": {
    "defaultMessage": "Private API key"
  },
  "socialExport.dailymotion.connect.loginDescription": {
    "defaultMessage": "We redirect you to Dailymotion to sign in and authorize access to your channel."
  },
  "socialExport.dailymotion.connect.loginName": {
    "defaultMessage": "Dailymotion account"
  },
  "socialExport.dailymotion.connectApiKeyTitle": {
    "defaultMessage": "Connect Dailymotion via API key"
  },
  "socialExport.facebook.connect.businessDescription": {
    "defaultMessage": "Publish from Facebook Business accounts"
  },
  "socialExport.facebook.connect.businessName": {
    "defaultMessage": "Facebook Business"
  },
  "socialExport.facebook.connect.businessPermissions": {
    "defaultMessage": "Page access via Facebook Business. IMPORTANT: when granting permissions to the application, give access only to the page where you want to publish."
  },
  "socialExport.facebook.connect.standardDescription": {
    "defaultMessage": "Publish to Facebook pages"
  },
  "socialExport.facebook.connect.standardName": {
    "defaultMessage": "Facebook"
  },
  "socialExport.facebook.connect.standardPermissions": {
    "defaultMessage": "Page access. IMPORTANT: when granting permissions to the application, give access only to the page where you want to publish."
  },
  "socialExport.form.category": {
    "defaultMessage": "Category"
  },
  "socialExport.form.commaSeparatedValues": {
    "defaultMessage": "Comma separated values"
  },
  "socialExport.form.content": {
    "defaultMessage": "Content"
  },
  "socialExport.form.defaultValuesUploads": {
    "defaultMessage": "Default values for uploads"
  },
  "socialExport.form.deleteDelay": {
    "defaultMessage": "Delete delay (ms)"
  },
  "socialExport.form.deleteDelayHelper": {
    "defaultMessage": "Wait time before deleting (0-60000 ms, default: 2000)"
  },
  "socialExport.form.demoConfig": {
    "defaultMessage": "Demo configuration"
  },
  "socialExport.form.demoData": {
    "defaultMessage": "Demo data"
  },
  "socialExport.form.description": {
    "defaultMessage": "Description"
  },
  "socialExport.form.forKids": {
    "defaultMessage": "Content suitable for children"
  },
  "socialExport.form.idsSeparatedByComma": {
    "defaultMessage": "IDs separated by comma"
  },
  "socialExport.form.platform": {
    "defaultMessage": "Platform"
  },
  "socialExport.form.publishDateLabel": {
    "defaultMessage": "Publish date and time"
  },
  "socialExport.form.publishDelay": {
    "defaultMessage": "Publish delay (ms)"
  },
  "socialExport.form.publishDelayHelper": {
    "defaultMessage": "Wait time before publishing (0-60000 ms, default: 10000)"
  },
  "socialExport.form.publishImmediately": {
    "defaultMessage": "Publish immediately"
  },
  "socialExport.form.publishToFeed": {
    "defaultMessage": "Also publish to feed"
  },
  "socialExport.form.replyConfig": {
    "defaultMessage": "Reply configuration"
  },
  "socialExport.form.schedule": {
    "defaultMessage": "Schedule"
  },
  "socialExport.form.scheduling": {
    "defaultMessage": "Scheduling"
  },
  "socialExport.form.settings": {
    "defaultMessage": "Publication parameters"
  },
  "socialExport.form.shareToFeed": {
    "defaultMessage": "Also share to feed"
  },
  "socialExport.form.taggedUsers": {
    "defaultMessage": "Tagged users"
  },
  "socialExport.form.tags": {
    "defaultMessage": "Tags"
  },
  "socialExport.form.thumbnail": {
    "defaultMessage": "Thumbnail"
  },
  "socialExport.form.thumbnailAndSettings": {
    "defaultMessage": "Thumbnail and settings"
  },
  "socialExport.form.title": {
    "defaultMessage": "Title"
  },
  "socialExport.form.unsavedChangesLeavePrompt": {
    "defaultMessage": "Are you sure you want to leave? Unsaved changes will be lost."
  },
  "socialExport.form.uploadAsPrivate": {
    "defaultMessage": "Upload as private video"
  },
  "socialExport.history": {
    "defaultMessage": "History"
  },
  "socialExport.manage.configure": {
    "defaultMessage": "Configure"
  },
  "socialExport.manage.disconnect": {
    "defaultMessage": "Disconnect"
  },
  "socialExport.mediaLimits.blocked": {
    "defaultMessage": "The video exceeds the platform's maximum allowed duration."
  },
  "socialExport.mediaLimits.blockedWithMax": {
    "defaultMessage": "The video exceeds the platform's maximum allowed duration ({maxMinutes} min)."
  },
  "socialExport.mediaLimits.needsTranscoding": {
    "defaultMessage": "The video size exceeds the platform limit; it will be reduced to {quality}p so it can be published."
  },
  "socialExport.mediaLimits.platformDisplaysLower": {
    "defaultMessage": "{platformName} will display it at up to {quality}p."
  },
  "socialExport.publish.chip.cancelled": {
    "defaultMessage": "Cancelled"
  },
  "socialExport.publish.chip.error": {
    "defaultMessage": "Error"
  },
  "socialExport.publish.chip.errorCode": {
    "defaultMessage": "Code: {errorCode}"
  },
  "socialExport.publish.chip.inProgress": {
    "defaultMessage": "In progress"
  },
  "socialExport.publish.chip.published": {
    "defaultMessage": "Published"
  },
  "socialExport.publish.chip.scheduled": {
    "defaultMessage": "Scheduled"
  },
  "socialExport.publish.chip.waitingForMedia": {
    "defaultMessage": "Waiting for media"
  },
  "socialExport.publish.connectionNotReady": {
    "defaultMessage": "The social connection is still loading; please try again in a moment."
  },
  "socialExport.publish.createdBy": {
    "defaultMessage": "Created by {user}"
  },
  "socialExport.publish.deleteFromPlatform": {
    "defaultMessage": "Delete from {platform}"
  },
  "socialExport.publish.deleteScheduledPublishMessage": {
    "defaultMessage": "Are you sure you want to delete this scheduled publication? This action cannot be undone."
  },
  "socialExport.publish.deleteScheduledPublishTitle": {
    "defaultMessage": "Delete scheduled publication"
  },
  "socialExport.publish.deleteVideoFromPlatformMessage": {
    "defaultMessage": "Are you sure you want to delete this video from the platform? This action cannot be undone."
  },
  "socialExport.publish.deleteVideoFromPlatformTitle": {
    "defaultMessage": "Delete video from {platform}"
  },
  "socialExport.publish.editionWithName": {
    "defaultMessage": "Edit: {name}"
  },
  "socialExport.publish.error.youtubeReconnectRequired": {
    "defaultMessage": "YouTube credentials are outdated. You need to reconnect the account."
  },
  "socialExport.publish.errorDeletingPublication": {
    "defaultMessage": "An error occurred while deleting the publication"
  },
  "socialExport.publish.errorDeletingVideo": {
    "defaultMessage": "An error occurred while deleting the video"
  },
  "socialExport.publish.errorPublishingNow": {
    "defaultMessage": "An error occurred while publishing immediately"
  },
  "socialExport.publish.forKidsDescription": {
    "defaultMessage": "The platform's restrictions for content aimed at children will apply."
  },
  "socialExport.publish.manageVideo": {
    "defaultMessage": "Manage video on {platform}"
  },
  "socialExport.publish.mediaSelector.edition": {
    "defaultMessage": "Edit"
  },
  "socialExport.publish.mediaSelector.label": {
    "defaultMessage": "Video to publish"
  },
  "socialExport.publish.mediaSelector.originalMedia": {
    "defaultMessage": "Original media"
  },
  "socialExport.publish.mediaSelector.renderNotReadyComposition": {
    "defaultMessage": "This edit's video is not generated yet. Generate it from the Edits tab."
  },
  "socialExport.publish.mediaSelector.renderNotReadyFragment": {
    "defaultMessage": "This edit's video has not been generated yet. Generate it from the edits tab."
  },
  "socialExport.publish.noAdditionalActions": {
    "defaultMessage": "The platform does not allow any additional action"
  },
  "socialExport.publish.noAllowedSourceError": {
    "defaultMessage": "There is no available source to publish for this station."
  },
  "socialExport.publish.noOAuthConnectionForPlatform": {
    "defaultMessage": "{platformName} is not connected for this station."
  },
  "socialExport.publish.noPlatformsToPublish": {
    "defaultMessage": "No platforms to publish to"
  },
  "socialExport.publish.noRenderedEdit": {
    "defaultMessage": "There is no edit with a generated video to publish."
  },
  "socialExport.publish.noStation": {
    "defaultMessage": "This composition has no station assigned."
  },
  "socialExport.publish.panorama.goToEdits": {
    "defaultMessage": "Go to edits"
  },
  "socialExport.publish.panorama.noConnectedPlatforms": {
    "defaultMessage": "There are no connected platforms to publish to."
  },
  "socialExport.publish.panorama.noSourcesComposition": {
    "defaultMessage": "To publish on social networks you need to generate a video from a video edit."
  },
  "socialExport.publish.panorama.noSourcesFragment": {
    "defaultMessage": "To publish on social networks, you need to generate a video from the fragment."
  },
  "socialExport.publish.panorama.notPublishedComposition": {
    "defaultMessage": "You have not published this composition on social networks yet."
  },
  "socialExport.publish.panorama.notPublishedFragment": {
    "defaultMessage": "You have not published this fragment on social networks yet."
  },
  "socialExport.publish.platformSwitcherLabel": {
    "defaultMessage": "Platform"
  },
  "socialExport.publish.postPublishProcessingNotice": {
    "defaultMessage": "After you finish publishing, it may take a few minutes for the content to process and be visible on your profile."
  },
  "socialExport.publish.publicationDeleted": {
    "defaultMessage": "Publication deleted"
  },
  "socialExport.publish.publicationsSectionTitle": {
    "defaultMessage": "Publications ({count})"
  },
  "socialExport.publish.publicationStarted": {
    "defaultMessage": "Publication started"
  },
  "socialExport.publish.publishedOn": {
    "defaultMessage": "Published on:"
  },
  "socialExport.publish.publishImmediatelyDescription": {
    "defaultMessage": "Turn off to choose a future publication date and time"
  },
  "socialExport.publish.publishNow": {
    "defaultMessage": "Publish now"
  },
  "socialExport.publish.publishNowConfirmMessage": {
    "defaultMessage": "Are you sure you want to publish this video now instead of waiting for the scheduled date?"
  },
  "socialExport.publish.publishNowConfirmTitle": {
    "defaultMessage": "Publish now"
  },
  "socialExport.publish.publishTo": {
    "defaultMessage": "Publish to"
  },
  "socialExport.publish.publishToSectionTitle": {
    "defaultMessage": "Publish to"
  },
  "socialExport.publish.publishToSocialNetworks": {
    "defaultMessage": "Publish to social networks"
  },
  "socialExport.publish.retry": {
    "defaultMessage": "Retry"
  },
  "socialExport.publish.scheduledAlertTitle": {
    "defaultMessage": "Scheduled publication"
  },
  "socialExport.publish.sectionTitle": {
    "defaultMessage": "Social networks"
  },
  "socialExport.publish.sendToPlatform": {
    "defaultMessage": "Publish to {platformName}"
  },
  "socialExport.publish.shareToFeedDescription": {
    "defaultMessage": "Besides the reel, the post will also appear in the account's main feed."
  },
  "socialExport.publish.startPublicationError": {
    "defaultMessage": "An error occurred while starting the publication, please contact support"
  },
  "socialExport.publish.uploadAsPrivateDescription": {
    "defaultMessage": "The video stays visible only on the account until it is published publicly"
  },
  "socialExport.publish.uploadDetail.publishedTitle": {
    "defaultMessage": "Published"
  },
  "socialExport.publish.videoDeletedFromPlatform": {
    "defaultMessage": "Video deleted from platform"
  },
  "socialExport.publish.videoPreview.title": {
    "defaultMessage": "Video preview"
  },
  "socialExport.publish.videoWillPublishAt": {
    "defaultMessage": "The video will be published on:"
  },
  "socialExport.publish.viewVideo": {
    "defaultMessage": "View video"
  },
  "socialExport.publish.waitingPublicLink": {
    "defaultMessage": "Waiting for public link"
  },
  "socialExport.select.none": {
    "defaultMessage": "None"
  },
  "socialExport.settings.updated": {
    "defaultMessage": "Configuration updated successfully"
  },
  "socialExport.rudo.accessToken": {
    "defaultMessage": "Access token"
  },
  "socialExport.rudo.accessTokenHelper": {
    "defaultMessage": "Static token from your Rudo.video account"
  },
  "socialExport.rudo.connectApiKeyTitle": {
    "defaultMessage": "Connect Rudo with access token"
  },
  "socialExport.rudo.displayName": {
    "defaultMessage": "Display name"
  },
  "socialExport.rudo.displayNameHelper": {
    "defaultMessage": "Optional. Useful if you connect more than one Rudo account."
  },
  "socialExport.rudo.folder.create": {
    "defaultMessage": "Create folder"
  },
  "socialExport.rudo.folder.createCancel": {
    "defaultMessage": "Cancel"
  },
  "socialExport.rudo.folder.createSubmit": {
    "defaultMessage": "Create"
  },
  "socialExport.rudo.folder.createSuccess": {
    "defaultMessage": "Folder created"
  },
  "socialExport.rudo.folder.createTitle": {
    "defaultMessage": "New folder"
  },
  "socialExport.rudo.folder.helper": {
    "defaultMessage": "Destination folder on Rudo"
  },
  "socialExport.rudo.folder.label": {
    "defaultMessage": "Folder"
  },
  "socialExport.rudo.folder.name": {
    "defaultMessage": "Folder name"
  },
  "socialExport.rudo.folder.noOptions": {
    "defaultMessage": "No folders available"
  },
  "socialExport.rudo.restriction.label": {
    "defaultMessage": "VOD restriction"
  },
  "socialExport.rudo.restriction.none": {
    "defaultMessage": "No restriction"
  },
  "socialExport.rudo.restriction.premium": {
    "defaultMessage": "Premium"
  },
  "socialExport.rudo.restriction.registration": {
    "defaultMessage": "Registered users only"
  },
  "socialExport.tiktok.disclosure.brandedContent.description": {
    "defaultMessage": "You are promoting another brand or a third party. This video will be classified as Branded Content."
  },
  "socialExport.tiktok.disclosure.brandedContent.label": {
    "defaultMessage": "Branded content"
  },
  "socialExport.tiktok.disclosure.brandedContentAndMusicAgree": {
    "defaultMessage": "By posting, you agree to TikTok's {brandedContentLink} and {musicLink}."
  },
  "socialExport.tiktok.disclosure.brandedContentPolicyLink": {
    "defaultMessage": "Branded Content Policy"
  },
  "socialExport.tiktok.disclosure.brandedContentVisibilityCannotBePrivate": {
    "defaultMessage": "Privacy for third-party branded promotional content cannot be \"Only me\"."
  },
  "socialExport.tiktok.disclosure.brandedContentVisibilityTooltip": {
    "defaultMessage": "Branded content visibility cannot be set to private."
  },
  "socialExport.tiktok.disclosure.description": {
    "defaultMessage": "Turn on to disclose that this video promotes goods or services in exchange for something of value. Your video could promote yourself, a third party, or both."
  },
  "socialExport.tiktok.disclosure.labelPaidPartnership": {
    "defaultMessage": "Your video will be labeled as 'Paid partnership'."
  },
  "socialExport.tiktok.disclosure.labelPaidPartnershipAlert": {
    "defaultMessage": "Your video will be labeled as 'Paid partnership'. This cannot be changed once your video is posted."
  },
  "socialExport.tiktok.disclosure.labelPromotionalContent": {
    "defaultMessage": "Your video will be labeled as 'Promotional content'."
  },
  "socialExport.tiktok.disclosure.musicUsageAgree": {
    "defaultMessage": "By posting, you agree to our {link}."
  },
  "socialExport.tiktok.disclosure.musicUsageConfirmationLink": {
    "defaultMessage": "Music Usage Confirmation"
  },
  "socialExport.tiktok.disclosure.promotionalLabel": {
    "defaultMessage": "Your video will be labeled \"Promotional content\". This cannot be changed once your video is posted."
  },
  "socialExport.tiktok.disclosure.selectAtLeastOneHint": {
    "defaultMessage": "You need to indicate if your content promotes yourself, a third party, or both."
  },
  "socialExport.tiktok.disclosure.toggle": {
    "defaultMessage": "Disclose video content"
  },
  "socialExport.tiktok.disclosure.yourBrand.description": {
    "defaultMessage": "You are promoting yourself or your own business. This video will be classified as Brand Organic."
  },
  "socialExport.tiktok.disclosure.yourBrand.label": {
    "defaultMessage": "Your brand"
  },
  "socialExport.tiktok.privacy.followers": {
    "defaultMessage": "Followers"
  },
  "socialExport.tiktok.privacy.friends": {
    "defaultMessage": "Friends"
  },
  "socialExport.tiktok.privacy.public": {
    "defaultMessage": "Public"
  },
  "socialExport.tiktok.privacy.self": {
    "defaultMessage": "Only me"
  },
  "socialExport.tiktok.settings.allowComment": {
    "defaultMessage": "Comment"
  },
  "socialExport.tiktok.settings.allowDuet": {
    "defaultMessage": "Duet"
  },
  "socialExport.tiktok.settings.allowStitch": {
    "defaultMessage": "Stitch"
  },
  "socialExport.tiktok.settings.allowUsersTo": {
    "defaultMessage": "Allow users to "
  },
  "socialExport.tiktok.settings.disabledByTiktokPrivacyTooltip": {
    "defaultMessage": "Disabled in your TikTok account privacy settings."
  },
  "socialExport.tiktok.settings.privacyLabel": {
    "defaultMessage": "Privacy"
  },
  "socialExport.twitter.replyEveryone": {
    "defaultMessage": "Everyone"
  },
  "socialExport.twitter.replyFollowing": {
    "defaultMessage": "People you follow"
  },
  "socialExport.twitter.replyMentioned": {
    "defaultMessage": "Mentioned users"
  },
  "socialExport.twitter.replySubscribers": {
    "defaultMessage": "Subscribers"
  },
  "socialExport.twitter.replyVerified": {
    "defaultMessage": "Verified"
  },
  "socialExport.uploaded.columnFragment": {
    "defaultMessage": "Fragment"
  },
  "socialExport.uploaded.columnPublished": {
    "defaultMessage": "Published"
  },
  "socialExport.uploaded.columnStation": {
    "defaultMessage": "Station"
  },
  "socialExport.uploaded.columnStatus": {
    "defaultMessage": "Status"
  },
  "socialExport.uploaded.linkLabel": {
    "defaultMessage": "Published videos"
  },
  "socialExport.uploaded.title": {
    "defaultMessage": "Recently published videos"
  },
  "socialExport.youtube.category": {
    "defaultMessage": "Category"
  },
  "socialExport.youtube.connect.advancedDescription": {
    "defaultMessage": "Manage playlists and delete videos"
  },
  "socialExport.youtube.connect.advancedName": {
    "defaultMessage": "Advanced mode"
  },
  "socialExport.youtube.connect.advancedPermissions": {
    "defaultMessage": "Upload videos, add to playlists, and delete videos"
  },
  "socialExport.youtube.connect.basicDescription": {
    "defaultMessage": "Publish videos without managing playlists or deleting"
  },
  "socialExport.youtube.connect.basicName": {
    "defaultMessage": "Basic mode"
  },
  "socialExport.youtube.connect.basicPermissions": {
    "defaultMessage": "Upload videos only"
  },
  "socialExport.youtube.idealSize": {
    "defaultMessage": "Ideal size: 1280 x 720 px"
  },
  "socialExport.youtube.madeForKids": {
    "defaultMessage": "Content suitable for children"
  },
  "socialExport.youtube.playlist.helperText": {
    "defaultMessage": "Select one or more playlists"
  },
  "socialExport.youtube.playlist.label": {
    "defaultMessage": "Playlists"
  },
  "socialExport.youtube.playlist.noManagePermissions": {
    "defaultMessage": "The current connection does not have permissions to manage playlists. You must reconnect to grant those permissions."
  },
  "socialExport.youtube.playlist.noOptions": {
    "defaultMessage": "No playlists available"
  },
  "socialExport.youtube.playlist.notFound": {
    "defaultMessage": "Playlist not found?"
  },
  "socialExport.youtube.playlist.privacyStatus.private": {
    "defaultMessage": "Private"
  },
  "socialExport.youtube.playlist.privacyStatus.public": {
    "defaultMessage": "Public"
  },
  "socialExport.youtube.playlist.privacyStatus.unlisted": {
    "defaultMessage": "Unlisted"
  },
  "socialExport.youtube.playlist.refresh": {
    "defaultMessage": "Refresh list"
  },
  "socialExport.youtube.playlist.videoCount": {
    "defaultMessage": "{count, plural, one {# video} other {# videos}}"
  },
  "stationConfig.noPrompts": {
    "defaultMessage": "No prompts registered"
  },
  "stations.noVideoStations": {
    "defaultMessage": "No video stations registered"
  },
  "stations.selector.favorites": {
    "defaultMessage": "Favorites"
  },
  "stations.selector.myStations": {
    "defaultMessage": "My stations"
  },
  "stations.selector.recent": {
    "defaultMessage": "Recent"
  },
  "stations.selector.removeRecent": {
    "defaultMessage": "Remove from recent"
  },
  "stations.selector.shared": {
    "defaultMessage": "External stations"
  },
  "stations.selector.sharedGroup": {
    "defaultMessage": "{name}"
  },
  "streamBox.device.coords": {
    "defaultMessage": "(Lat. {lat}, Long. {lng})"
  },
  "streamBox.listScreen.manageBtn": {
    "defaultMessage": "Manage device"
  },
  "streamBox.listScreen.noDevices": {
    "defaultMessage": "No devices found"
  },
  "streamBox.listScreen.title": {
    "defaultMessage": "StreamBox devices"
  },
  "streamBox.nav.title": {
    "defaultMessage": "Stream Box"
  },
  "streamBox.props.device": {
    "defaultMessage": "Device"
  },
  "streamBox.props.id": {
    "defaultMessage": "ID"
  },
  "streamBox.props.location": {
    "defaultMessage": "Location"
  },
  "streamBox.props.service": {
    "defaultMessage": "Service"
  },
  "streamBox.props.services": {
    "defaultMessage": "Services"
  },
  "streamBox.props.status": {
    "defaultMessage": "Status"
  },
  "streamBox.viewScreen.actions.reboot.btn": {
    "defaultMessage": "Reboot"
  },
  "streamBox.viewScreen.actions.reboot.confirm": {
    "defaultMessage": "Do you really wish to restart the device?"
  },
  "streamBox.viewScreen.actions.reboot.done": {
    "defaultMessage": "Device reboot requested"
  },
  "streamBox.viewScreen.actions.rename.btn": {
    "defaultMessage": "Rename"
  },
  "streamBox.viewScreen.actions.rename.done": {
    "defaultMessage": "Device renamed"
  },
  "streamBox.viewScreen.actions.rename.label": {
    "defaultMessage": "New name"
  },
  "streamBox.viewScreen.actions.rename.title": {
    "defaultMessage": "Rename device"
  },
  "streamBox.viewScreen.actions.setCoords.button": {
    "defaultMessage": "Set coordinates"
  },
  "streamBox.viewScreen.actions.setCoords.done": {
    "defaultMessage": "Coordinates updated"
  },
  "streamBox.viewScreen.actions.setCoords.latitude": {
    "defaultMessage": "Latitude"
  },
  "streamBox.viewScreen.actions.setCoords.longitude": {
    "defaultMessage": "Longitude"
  },
  "streamBox.viewScreen.actions.setCoords.title": {
    "defaultMessage": "Set coordinates"
  },
  "streamBox.viewScreen.clickLocation": {
    "defaultMessage": "Click to show location on map"
  },
  "streamBox.viewScreen.loading": {
    "defaultMessage": "Loading device"
  },
  "streamBox.viewScreen.services.actions.config.btn": {
    "defaultMessage": "Config"
  },
  "streamBox.viewScreen.services.actions.config.title": {
    "defaultMessage": "Configure service"
  },
  "streamBox.viewScreen.services.actions.restart.btn": {
    "defaultMessage": "Restart"
  },
  "streamBox.viewScreen.services.actions.restart.done": {
    "defaultMessage": "Service restart requested"
  },
  "streamBox.viewScreen.services.actions.restart.error": {
    "defaultMessage": "Could not restart service"
  },
  "streamBox.viewScreen.services.actions.restart.prompt": {
    "defaultMessage": "Do you really wish to restart the service?"
  },
  "streamBox.viewScreen.services.actions.start.btn": {
    "defaultMessage": "Start"
  },
  "streamBox.viewScreen.services.actions.start.done": {
    "defaultMessage": "Service start requested"
  },
  "streamBox.viewScreen.services.actions.start.error": {
    "defaultMessage": "Could not start service"
  },
  "streamBox.viewScreen.services.actions.start.prompt": {
    "defaultMessage": "Do you really wish to start the service?"
  },
  "streamBox.viewScreen.services.actions.stop.btn": {
    "defaultMessage": "Stop"
  },
  "streamBox.viewScreen.services.actions.stop.done": {
    "defaultMessage": "Service stop requested"
  },
  "streamBox.viewScreen.services.actions.stop.error": {
    "defaultMessage": "Could not stop service"
  },
  "streamBox.viewScreen.services.actions.stop.prompt": {
    "defaultMessage": "Do you really wish to stop the service?"
  },
  "streamBox.viewScreen.services.config.done": {
    "defaultMessage": "Service config updated"
  },
  "streamBox.viewScreen.services.config.error": {
    "defaultMessage": "Could not update service config"
  },
  "streamBox.viewScreen.services.config.noVars": {
    "defaultMessage": "There are no available variables for this service"
  },
  "streamBox.viewScreen.title": {
    "defaultMessage": "Device {deviceName} / StreamBox"
  },
  "tagGroups.defaultGroup": {
    "defaultMessage": "Default group"
  },
  "tagGroups.groupName": {
    "defaultMessage": "Group name"
  },
  "tagGroups.tags": {
    "defaultMessage": "Tags"
  },
  "tagGroups.tagsPlaceholder": {
    "defaultMessage": "Type and press Enter/comma to add tags"
  },
  "tours.driver.done": {
    "defaultMessage": "Done"
  },
  "tours.driver.new": {
    "defaultMessage": "New"
  },
  "tours.driver.next": {
    "defaultMessage": "Next"
  },
  "tours.driver.previous": {
    "defaultMessage": "Previous"
  },
  "tours.driver.progress": {
    "defaultMessage": "{current} of {total}"
  },
  "ui.copyUrlButton.copyLink": {
    "defaultMessage": "Copy link to share"
  },
  "ui.stationsFilter.label": {
    "defaultMessage": "Filter stations"
  },
  "ui.stationsFilter.optionType.long.individualStation": {
    "defaultMessage": "Individual station"
  },
  "ui.stationsFilter.optionType.long.stationGroup": {
    "defaultMessage": "Station group"
  },
  "ui.stationsFilter.optionType.long.stationType": {
    "defaultMessage": "Station type"
  },
  "ui.stationsFilter.optionType.short.individualStation": {
    "defaultMessage": "Station"
  },
  "ui.stationsFilter.optionType.short.stationGroup": {
    "defaultMessage": "Group"
  },
  "ui.stationsFilter.optionType.short.stationType": {
    "defaultMessage": "Type"
  },
  "ui.stationsFilter.placeholder": {
    "defaultMessage": "Choose a station, group or type..."
  },
  "ui.stationsSelector.enterToGo": {
    "defaultMessage": "Press Enter to go"
  },
  "ui.stationsSelector.searchPlaceholder": {
    "defaultMessage": "Search station"
  },
  "ui.versionChecker.appUpToDate": {
    "defaultMessage": "App is up to date ({version})"
  },
  "ui.versionChecker.newVersionAvailable": {
    "defaultMessage": "A new app version is available"
  },
  "ui.versionChecker.newVersionAvailableExpand": {
    "defaultMessage": "New version available, click to expand"
  },
  "ui.versionChecker.newVersionAvailableReload": {
    "defaultMessage": "New version available, click to update"
  },
  "ui.versionChecker.update": {
    "defaultMessage": "Update"
  },
  "userPermission.inheritsFromGroup": {
    "defaultMessage": "Inherits from group"
  },
  "users.chipList.unknownUser": {
    "defaultMessage": "Unknown user"
  },
  "validateUpload.fileLabel": {
    "defaultMessage": "File:"
  },
  "validateUpload.itemsCreated": {
    "defaultMessage": "{count} items created"
  },
  "validateUpload.process": {
    "defaultMessage": "Process"
  },
  "validateUpload.processNewFile": {
    "defaultMessage": "Process new file"
  },
  "validateUpload.tryAgain": {
    "defaultMessage": "Try again"
  },
  "validateUpload.verifyError": {
    "defaultMessage": "An error occurred while verifying the file"
  },
  "validation.maxValue60000": {
    "defaultMessage": "Must be less than or equal to 60000"
  },
  "validation.minValueZero": {
    "defaultMessage": "Must be greater than or equal to 0"
  },
  "videoEditions.autoEditName": {
    "defaultMessage": "Edit {n}"
  },
  "videoEditions.category.draftChip": {
    "defaultMessage": "Drafts & in progress ({count})"
  },
  "videoEditions.category.generatedChip": {
    "defaultMessage": "Generated ({count})"
  },
  "videoEditions.clone": {
    "defaultMessage": "Clone edit"
  },
  "videoEditions.cloneDialog.nameLabel": {
    "defaultMessage": "Name"
  },
  "videoEditions.cloneDialog.submit": {
    "defaultMessage": "Clone"
  },
  "videoEditions.cloneDialog.title": {
    "defaultMessage": "Clone edit"
  },
  "videoEditions.createEdit": {
    "defaultMessage": "Create edit"
  },
  "videoEditions.deleteConfirm": {
    "defaultMessage": "Delete this edit? This action cannot be undone."
  },
  "videoEditions.editCard.publishedOn": {
    "defaultMessage": "Published on"
  },
  "videoEditions.emptyDraftTab": {
    "defaultMessage": "No drafts or in-progress renders in this section"
  },
  "videoEditions.emptyGeneratedTab": {
    "defaultMessage": "No generated videos yet"
  },
  "videoEditions.emptyHelp": {
    "defaultMessage": "No edits yet"
  },
  "videoEditions.finishedOn": {
    "defaultMessage": "Generated"
  },
  "videoEditions.status.generated": {
    "defaultMessage": "Ready to publish"
  },
  "videoEditions.status.notGenerated": {
    "defaultMessage": "Not generated"
  },
  "videoEditions.tabTitle": {
    "defaultMessage": "edits"
  },
  "youtube.cuepoints.column.createdAt": {
    "defaultMessage": "Insertion date/time"
  },
  "youtube.cuepoints.column.cuepointId": {
    "defaultMessage": "Cuepoint ID"
  },
  "youtube.cuepoints.column.videoId": {
    "defaultMessage": "Video ID"
  },
  "youtube.cuepoints.insert.button": {
    "defaultMessage": "Insert cuepoint"
  },
  "youtube.cuepoints.insert.dialogTitle": {
    "defaultMessage": "Insert cuepoint manually"
  },
  "youtube.cuepoints.insert.durationHelper": {
    "defaultMessage": "Between 1 and 300 seconds"
  },
  "youtube.cuepoints.insert.durationLabel": {
    "defaultMessage": "Duration (seconds)"
  },
  "youtube.cuepoints.insert.durationMax": {
    "defaultMessage": "Maximum duration is 300 seconds"
  },
  "youtube.cuepoints.insert.durationMin": {
    "defaultMessage": "Minimum duration is 1 second"
  },
  "youtube.cuepoints.insert.durationRequired": {
    "defaultMessage": "Duration is required"
  },
  "youtube.cuepoints.insert.error": {
    "defaultMessage": "Could not insert cuepoint"
  },
  "youtube.cuepoints.insert.submit": {
    "defaultMessage": "Insert"
  },
  "youtube.cuepoints.insert.success": {
    "defaultMessage": "Cuepoint inserted successfully"
  },
  "youtube.cuepoints.manageCuepoints": {
    "defaultMessage": "View registered cuepoints"
  },
  "youtube.cuepoints.manageCuepointsAlertTitle": {
    "defaultMessage": "YouTube cuepoints"
  },
  "youtube.cuepoints.pageTitle": {
    "defaultMessage": "Cuepoints"
  },
  "youtube.privacyStatus.label": {
    "defaultMessage": "Privacy status"
  },
  "youtube.privacyStatus.private": {
    "defaultMessage": "Private"
  },
  "youtube.privacyStatus.public": {
    "defaultMessage": "Public"
  },
  "youtube.privacyStatus.unlisted": {
    "defaultMessage": "Unlisted"
  }
}
